<template>
  <!-- 运费订单 -->
  <div class="billOperationRecord public_Spacing">
    <div class="pulbic_oparetionBlock" style="margin-bottom: 1px;">
      <div class="public_criteriaRange">
        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty">企业：</label>
          <el-select
            class="public_optionSty dropDown_Define"
            @change="erpChange"
            v-model="enterpriseTwo"
            placeholder="请选择"
          >
            <el-option
              v-for="item in enterpriseTwoOptionList"
              :key="item.SETTB99ID"
              :label="item.SETTB99CA00"
              :value="item.SETTB99ID"
            >
            </el-option>
          </el-select>
        </div>
      
        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty">物料：</label>
          <el-select
            class="public_optionSty dropDown_Define"
            v-model="materielMo"
            placeholder="请选择"
            filterable
          >
            <el-option
              v-for="item in materielOptions"
              :key="item.SETTB109ID"
              :label="item.SETTB109CA00"
              :value="item.SETTB109ID"
            >
            </el-option>
          </el-select>
        </div>
        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty">状态：</label>
          <el-select
            class="public_optionSty dropDown_Define"
            v-model="SETTB122CA07"
            placeholder="请选择"
          >
            <el-option
              v-for="item in dataStatusOperation"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty" style="width:7vw;">运费结算方式：</label>
          <el-select
            class="public_optionSty dropDown_Define"
            v-model="ORMTB470CA58"
            placeholder="请选择"
          >
            <el-option
              v-for="item in dataStatusOperation0"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty">车牌号：</label>
          <div class="el-select public_optionSty">
            <div class="el-input el-input--suffix">
              <input
                class="pulic_carNumber"
                type="text"
                placeholder="请输入"
                v-model="carNumber"
              />
            </div>
          </div>
        </div>
       
        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty">离线订单：</label>
          <el-select
            class="public_optionSty dropDown_Define"
            v-model="lxorde"
            placeholder="请选择"
          >
            <el-option
              v-for="item in orlxOrdeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty">时间：</label>
          <el-select
            class="public_optionSty dropDown_Define"
            v-model="timeType"
            placeholder="请选择"
          >
            <el-option label="接单时间" value="1"> </el-option>
            <el-option label="出厂时间" value="2"> </el-option>
            <el-option label="卸货时间" value="4"> </el-option>
            <el-option label="完成时间" value="3"> </el-option>
          </el-select>
        </div>
        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty">修改流水：</label>
          <el-select
            class="public_optionSty dropDown_Define"
            v-model="xgorde"
            placeholder="请选择"
          >
            <el-option
              v-for="item in orXgOrdeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div
          class="public_oparetionBlock_Menu"
          v-if="this.uobj.pertb005.pertb005cb00 == 'CUS-1'"
        >
          <label class="public_lbSty">接单人：</label>
          <el-select
            class="public_optionSty dropDown_Define"
            v-model="ORMTB470CA12"
            placeholder="请选择"
            :clearable="true"
            filterable
          >
            <el-option
              v-for="item in customerOptions"
              :key="item.ORMTB410ID"
              :label="item.ORMTB410CA00"
              :value="item.ORMTB410CA00"
            >
            </el-option>
          </el-select>
        </div>
        <div
          class="public_oparetionBlock_Menu"
          v-if="this.uobj.pertb005.pertb005cb00 == 'CUS-1'"
        >
          <label class="public_lbSty" style="width: 7vw;">发单人：</label>
          <el-select
            class="public_optionSty dropDown_Define"
            v-model="ORMTB470CA40"
            placeholder="请选择"
            :clearable="true"
            filterable
          >
            <el-option
              v-for="item in customerOptions"
              :key="item.ORMTB410ID"
              :label="item.ORMTB410CA00"
              :value="item.ORMTB410CA00"
            >
            </el-option>
          </el-select>
        </div>
        <div
          class="public_oparetionBlock_Menu"
          v-if="this.uobj.pertb005.pertb005cb00 == 'CUS-1'"
        >
          <label class="public_lbSty">货主：</label>
          <el-select
            class="public_optionSty dropDown_Define"
            v-model="ORMTB410CA04"
            placeholder="请选择"
            :clearable="true"
            filterable
          >
            <el-option
              v-for="item in customerOptions"
              :key="item.ORMTB410ID"
              :label="item.ORMTB410CA00"
              :value="item.ORMTB410CA00"
            >
            </el-option>
          </el-select>
        </div>
		<div class="public_oparetionBlock_Menu">
		  <label class="public_lbSty">错单：</label>
		  <el-select
		    class="public_optionSty dropDown_Define"
		    v-model="cdorde"
		    placeholder="请选择"
		  >
		    <el-option
		      v-for="item in orCdOrdeOptions"
		      :key="item.value"
		      :label="item.label"
		      :value="item.value"
		    >
		    </el-option>
		  </el-select>
		</div>
      </div>
      <div class="public_operatArea">
        <span
          class="pulic_operatArea_now pulic_cursor"
          :class="dateNowDayActive ? 'public_dateActive' : ''"
          @click="getNowDay"
          >当日</span
        >
        <span
          class="public_operatArea_yesterday pulic_cursor"
          :class="dateYesterdayActive ? 'public_dateActive' : ''"
          @click="getYesterday"
          >昨天</span
        >
        <span
          class="pulic_operatArea_now pulic_cursor"
          :class="dateNowMonthActive ? 'public_dateActive' : ''"
          @click="sameMonth"
          >当月</span
        >
        <span
          class="public_operatArea_yesterday pulic_cursor"
          :class="dateLastMonthActive ? 'public_dateActive' : ''"
          @click="lastMonth"
          >上月</span
        >
        <div class="public_operatArea_timePicker pulic_cursor">
          <el-date-picker
            v-model="date"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            :picker-options="startDateDisabled"
            @change="datePickerChange"
            start-placeholder="开始日"
            end-placeholder="结束日"
            class="pulic_cursor"
          >
          </el-date-picker>
        </div>
		
		<div class="public_oparetionBlock_Menu">
		  <label class="public_lbSty" style="padding-left: 20px;">订单出处：</label>
		  <el-select class="public_optionSty dropDown_Define" v-model="orderSource" placeholder="请选择">
		    <el-option v-for="item in orderSourceOpenOptions" :key="item.value" :label="item.label" :value="item.value">
		    </el-option>
		  </el-select>
		</div>
		
        <div class="public_operatBtn">
          <button
            @click="queryClick"
            class="public_saleWater_chaxun pulic_cursor"
            v-shiroHiden="solelist"
            id="查询"
          >
            <i class="iconfont icon-chaxun"></i>查询
          </button>
          <el-button
            class="public_saleWater_daochu pulic_cursor"
            :loading="loadingBut"
            @click="exports"
            v-shiroHiden="solelist"
            id="导出"
            ><i class="iconfont icon-daochu"></i>导出<span
              v-if="confirmTxt > 0"
              >{{ confirmTxt }}</span
            ></el-button
          >
          <el-popover ref="popover2" trigger="click">
            <div style="text-align: left;padding-left: 20px;padding-top: 8px;">
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
                >全选</el-checkbox
              >
              <div style="margin: 15px 0;"></div>
              <el-checkbox-group
                v-model="checkedCities"
                @change="handleCheckedCitiesChange"
              >
                <el-checkbox
                  style="display: block;"
                  class="salesWater_checkbox"
                  v-for="city in cities"
                  :label="city"
                  :key="city"
                  >{{ city }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </el-popover>
        </div>
      </div>
    </div>
    <div v-shiroHiden="solelist" id="统计" style="width: 100%;">
      <div class="pulbic_oparetionBlock public_statisticsInfo">
        <div class="public_statistics billDetails-statistics">
          <div class="public_statisticsContent">
            <img
              class="imgStatistics"
              src="../../assets/images/orderStatistics/money.png"
            />
            <div class="payType">物料金额</div>
          </div>
          <ul class="billDetails-ul">
            <li class="pulic_statistics_titlt">
              <span class="totolTitle">接单金额(元)</span
              ><span class="Amount" style="color: #08D691;">{{ pdje }}</span>
              <span class="totolTitle" style="padding-left: 20px;"
                >出厂金额(元)</span
              ><span class="singular">{{ jsje }}</span>
            </li>
            <li class="pulic_statistics_titlt">
              <span class="totolTitle">完成金额(元)</span
              ><span class="singular">{{ wcje }}</span>
            </li>
          </ul>
        </div>
        <div class="public_statistics billDetails-statistics">
          <div class="public_statisticsContent">
            <img
              class="imgStatistics"
              src="../../assets/images/orderStatistics/money.png"
            />
            <div class="payType">运费金额</div>
          </div>
          <ul class="billDetails-ul">
            <li class="pulic_statistics_titlt">
              <span class="totolTitle">接单运费(元)</span
              ><span class="Amount" style="color: #08D691;">{{ pdyf }}</span>
              <span class="totolTitle" style="padding-left: 20px;"
                >出厂运费(元)</span
              ><span class="singular">{{ jsyf }}</span>
            </li>
            <li class="pulic_statistics_titlt">
              <span class="totolTitle">扣除运费(元)</span
              ><span class="singular">{{ wcyf }}</span>

              <span class="totolTitle" style="padding-left: 20px;"
                >结算运费(元)</span
              ><span class="singular">{{ jsyfsjtj }}</span>

              <span
                class="totolTitle"
                style="padding-left: 20px;"
                v-if="uobj.pertb005.pertb005cb00 == 'CUS-1'"
                >管理费(元)</span
              ><span class="singular">{{ glf }}</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="pulbic_oparetionBlock public_statisticsInfo">
        <div class="public_statistics billDetails-statistics">
          <div class="public_statisticsContent">
            <img
              class="imgStatistics"
              src="../../assets/images/orderStatistics/trainNumber.png"
            />
            <!-- <i style="color: #FF9E4F!important;font-size: 20px;" class="iconfont icon-chongzhi1"></i> -->
            <div class="payType">车次</div>
          </div>
          <ul class="billDetails-ul">
            <li class="pulic_statistics_titlt">
              <span class="totolTitle">接单车次(单)</span
              ><span class="Amount" style="color: #199FFF;">{{ pdcc }}</span>
              <span class="totolTitle" style="padding-left: 20px;"
                >出厂车次(单)</span
              ><span class="singular">{{ jscc }}</span>
            </li>
            <li class="pulic_statistics_titlt">
              <span class="totolTitle">完成车次(单)</span
              ><span class="singular">{{ wccc }}</span>
            </li>
          </ul>
        </div>
        <div class="public_statistics billDetails-statistics">
          <div class="public_statisticsContent">
            <img
              class="imgStatistics"
              src="../../assets/images/orderStatistics/weight.png"
            />
            <!-- <i style="color: #08D691 !important;font-size: 20px;" class="iconfont icon-tuikuan1"></i> -->
            <div class="payType">重量</div>
          </div>
          <ul class="billDetails-ul">
            <li class="pulic_statistics_titlt">
              <span class="totolTitle">接单重量(吨)</span
              ><span class="Amount" style="color: #FF4500;">{{ pdzl }}</span>
              <span class="totolTitle" style="padding-left: 20px;"
                >出厂重量(吨)</span
              ><span class="singular">{{ jszl }}</span>
            </li>
            <li class="pulic_statistics_titlt">
              <span class="totolTitle">完成重量(吨)</span
              ><span class="singular">{{ wczl }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="billOperationRecord-table pulbic_table_container">
      <el-table
        tooltip-effect="dark"
        :data="tableData"
        style="width: 100%;"
        :default-sort="{ prop: 'waterNum', order: 'descending' }"
        :header-cell-style="{
          color: 'rgba(51,51,51,1)',
          background: 'rgba(184,227,255,1)',
          'font-weight': 'bold',
        }"
        class="public_tableColumn"
      >
        <el-table-column
          prop="ORMTB470CA16"
          sortable
          fixed="left"
          width="110"
          label="接单时间"
        >
        </el-table-column>
        <!-- <el-table-column prop="ORMTB470CA00" width="130" fixed="left" label="接单编号">
				</el-table-column> -->
        <el-table-column prop="ORMTB470CA05" width="130" label="装货地">
        </el-table-column>
        <el-table-column prop="ORMTB470CA33" width="130" label="卸货地">
        </el-table-column>
        <el-table-column prop="ORMTB470CA40" width="100" label="发单人">
        </el-table-column>
        <el-table-column prop="ORMTB410CA04" width="100" label="货主">
        </el-table-column>
        <el-table-column prop="ORMTB470CA14" width="100" label="运费(每吨)">
        </el-table-column>
        <el-table-column
          v-if="this.uobj.pertb005.pertb005cb00 == 'CUS-1'"
          prop="ORMTB470CA12"
          width="100"
          label="接单人"
        >
          <template slot-scope="scope">
            <p>
              <span>{{ scope.row.ORMTB470CA12 }}</span>
            </p>
            <p style="color: #999;">
              <span>{{ scope.row.ORMTB410CA02 }}</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in tableHeadList"
          :width="item.width"
          :prop="item.prop"
          :label="item.label"
          :key="index"
        >
        </el-table-column>
        <el-table-column width="130" label="出厂结算金额">
          <template slot-scope="scope">
            <p>
              <span v-if="scope.row.ORMTB470CA23">{{
                Number(scope.row.ORMTB470CA23 + scope.row.ORMTB470CA31).toFixed(
                  '2'
                )
              }}</span>
              <span v-if="!scope.row.ORMTB470CA23"></span>
            </p>
          </template>
        </el-table-column>
        <!-- </el-table-column> -->
        <el-table-column width="130" label="完成结算金额">
          <template slot-scope="scope">
            <p>
              <span v-if="scope.row.ORMTB470CC06">{{
                Number(scope.row.ORMTB470CC06 + scope.row.ORMTB470CC07).toFixed(
                  '2'
                ) || ''
              }}</span>
              <span v-if="!scope.row.ORMTB470CC06"></span>
            </p>
          </template>
        </el-table-column>
        <!-- </el-table-column> -->
        <!-- <el-table-column prop="ORMTB470CA12" width="130" label="流水号">
					<template slot-scope="scope">
						<p>
							<span>{{ scope.row.ORMTB470CA24 }}</span>
						</p>

					</template>
				</el-table-column> -->
        <el-table-column
          fixed="right"
          width="120"
          prop="ORMTB440CF01text"
          label="完成状态"
        >
          <template slot-scope="scope">{{
            scope.row.ORMTB440CF01text
          }}</template>
        </el-table-column>

        <el-table-column
          fixed="right"
          width="100"
          prop="auditText"
          label="申请状态"
        >
          <template slot-scope="scope">{{ scope.row.auditText }}</template>
        </el-table-column> 
		<el-table-column fixed="right" prop="source" width="100" label="订单出处">
		  <template slot-scope="scope">
		    <div :class="[scope.row.source == 0 ? 'orderBtn2' : 'orderBtn1', 'orderBtn']">{{ scope.row.source == 0 ? '客户' : '平台' }}
		    </div>
		  </template>
		</el-table-column>
		<el-table-column fixed="right" width="100" prop="ORMTB440CN00" label="">
		  <template slot-scope="scope">
		    <img
		      v-if="
		        scope.row.ORMTB470CN18&&
		          uobj.pertb005.pertb005cb00 == 'CUS-1'
		      "
		      class="imgStatistics"
		      src="../../assets/images/orderStatistics/cd.png"
		    />
		  </template>
		</el-table-column>
        <el-table-column fixed="right" width="100" prop="ORMTB470CN00" label="">
          <template slot-scope="scope">
            <img
              v-if="
                scope.row.ORMTB470CN00 == '1' &&
                  uobj.pertb005.pertb005cb00 == 'CUS-1'
              "
              class="imgStatistics"
              src="../../assets/images/orderStatistics/xg.png"
            />
          </template>
        </el-table-column>

        <el-table-column
          v-if="
            this.uobj.pertb005.pertb005cb00 == 'CUS-1' ||
              this.uobj.pertb005.pertb005cb00 == 'CUS-2'
          "
          label="操作"
          fixed="right"
          width="320"
        >
          <template slot-scope="scope">
            <el-button
              class="public_icon_xiangqing public_icon_width  public_icon_margin"
              type="primary"
              size="small"
              @click="DetailsClick(scope.row)"
              >详情</el-button
            >
            <el-button
              v-if="
                scope.row.ORMTB440CF01text == '已接单' ||
                  scope.row.ORMTB440CF01text == '提货中'
              "
              style="color: #FFA500 !important;"
              class="public_icon_xiangqing public_icon_width  public_icon_margin"
              type="primary"
              size="small"
              @click="ewmDetailsClick(scope.row)"
              >查看二维码</el-button
            >
            <el-button
              class="public_icon_hongchongred public_icon_width public_icon_margin"
              v-if="
                (scope.row.ORMTB470CD00 == 0 ||
                  scope.row.ORMTB470CD00 == -1 ||
                  scope.row.ORMTB470CD00 == -2 ||
                  scope.row.ORMTB470CD00 == 1) &&
                  scope.row.ORMTB470CA62 == 0 &&
                  uobj.pertb005.pertb005cb00 == 'CUS-1'
              "
              type="primary"
              size="small"
              id="冻结"
              v-shiroHiden="solelist"
              @click="djcancelOrder(scope.row, 1)"
              >冻结</el-button
            >
            <el-button
              class="public_icon_dayin public_icon_width public_icon_margin"
              v-if="
                (scope.row.ORMTB470CD00 == 0 ||
                  scope.row.ORMTB470CD00 == -1 ||
                  scope.row.ORMTB470CD00 == -2 ||
                  scope.row.ORMTB470CD00 == 1) &&
                  scope.row.ORMTB470CA62 == 1 &&
                  uobj.pertb005.pertb005cb00 == 'CUS-1'
              "
              type="success"
              size="small"
              id="解冻"
              v-shiroHiden="solelist"
              @click="djcancelOrder(scope.row, 0)"
              >解冻</el-button
            >
            <!-- <el-button class="public_icon_xiugai public_icon_width public_icon_margin"
							v-if="(scope.row.ORMTB470CD00==0||scope.row.ORMTB470CD00==1)&&uobj.pertb005.pertb005cb00=='CUS-1'"
							type="primary" size="small" id="取消订单" v-shiroHiden="solelist"
							@click="cancelOrder(scope.row)">取消订单</el-button> -->
            <el-button
              class="public_icon_xiangqing public_icon_width  public_icon_margin"
              v-if="
                scope.row.ORMTB470CA04 == '10000150' &&
                  scope.row.ORMTB470CN08 == 1
              "
              type="primary"
              id="取消要货计划"
              size="small"
              @click="cancelPlan(scope.row)"
              >取消要货计划</el-button
            >
            <el-button
              class="public_icon_xiangqing public_icon_width  public_icon_margin"
              v-if="
                scope.row.ORMTB470CD00 == '-2' &&
                  scope.row.ORMTB470CD01 == 0 &&
                  uobj.pertb005.pertb005cb00 == 'CUS-1'
              "
              type="primary"
              id="审核取消"
              v-shiroHiden="solelist"
              size="small"
              @click="isorderAudit(scope.row)"
              >审核取消</el-button
            >

            <el-button
              class="public_icon_xiangqing public_icon_width  public_icon_margin"
              v-if="scope.row.ORMTB470CD00 == '3'"
              type="primary"
              id="审核磅单"
              v-shiroHiden="solelist"
              size="small"
              @click="orderAudit(scope.row)"
              >审核磅单
            </el-button>
            <el-button
              class="public_icon_xiangqing public_icon_width  public_icon_margin"
              v-if="
                scope.row.ORMTB470CD00 == '2' ||
                  scope.row.ORMTB470CD00 == '3' ||
                  scope.row.ORMTB470CD00 == '4'
              "
              type="primary"
              id="审核磅单"
              v-shiroHiden="solelist"
              size="small"
              @click="orderAudit1(scope.row, 'hx')"
              >核销卸货磅单
            </el-button>

            <el-button
              style="color: #FF0000 !important;margin-left: 30px!important;"
              class="public_icon_xiangqing public_icon_width  public_icon_margin"
              type="primary"
              v-if="
                scope.row.ORMTB470CD00 == '2' ||
                  scope.row.ORMTB470CD00 == '3' ||
                  scope.row.ORMTB470CD00 == '4' ||
                  scope.row.ORMTB470CD00 == '5' ||
                  scope.row.ORMTB470CD00 == '-3'
              "
              size="small"
              @click="orderAudit2(scope.row)"
              id="上传磅单"
              v-shiroHiden="solelist"
              >上传卸货磅单
            </el-button>

            <el-button
              class="public_icon_xiangqing public_icon_width  public_icon_margin"
              v-if="
                scope.row.isauditOrder == 1 &&
                  uobj.pertb005.pertb005cb00 == 'CUS-1'
              "
              type="primary"
              size="small"
              @click="isorderAudit(scope.row)"
              id="审核派单"
              v-shiroHiden="solelist"
              >审核派单
            </el-button>
            <el-button
              class="public_icon_xiangqing public_icon_width  public_icon_margin"
              v-if="
                scope.row.ORMTB440CF01 == 4 &&
                  uobj.pertb005.pertb005cb00 == 'CUS-1' &&
                  scope.row.ORMTB440CF00 == 'ZG'
              "
              type="primary"
              size="small"
              @click="returnReceipt(scope.row)"
              id="确认回执"
              v-shiroHiden="solelist"
              >确认回执</el-button
            >
            <el-button
              v-if="
                scope.row.ORMTB430ID == 0 &&
                  scope.row.ORMTB470CD00 >= 0 &&
                  scope.row.ORMTB470CD00 < 2
              "
              class=""
              type="text"
              size="medium"
              @click="UploadClick(scope.row)"
              style="overflow: hidden;position: relative;padding: 0;cursor: pointer;"
            >
              <input
                @change="inputFileChange"
                ref="inputFile"
                type="file"
                name="inputFile"
                style="width:100%;height:100%;position: absolute;top: 0;left: 0;right: 0;bottom: 0;opacity: 0;cursor: pointer;font-size:0"
              />
              上传二维码
            </el-button>

            <!-- <el-button v-if="scope.row.ORMTB401CA01==='ZJ'&&(scope.row.ORMTB440CF01==6)" class="public_icon_xiugai public_icon_width public_icon_margin" type="primary" size="small" @click="inputWeightClick(scope.row)" id="完成订单">完成订单</el-button> -->
            <el-button
              v-if="
                scope.row.ORMTB430ID == '0' &&
                  (scope.row.ORMTB470CD00 == 0 ||
                    scope.row.ORMTB470CD00 == '1' ||
                    scope.row.ORMTB470CD00 == '-1')
              "
              class="public_icon_xiugai public_icon_width public_icon_margin"
              type="primary"
              v-shiroHiden="solelist"
              size="small"
              @click="inputWeightClick(scope.row)"
              id="出厂完成订单"
              >出厂完成订单
            </el-button>
			
			<el-button
			  class="public_icon_hongchongred public_icon_width public_icon_margin"
			  v-if="
			      uobj.pertb005.pertb005cb00 == 'CUS-1'
			  "
			  type="primary"
			  size="small"
			  @click="cdclDetailsClick(scope.row)"
			  >错单处理</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pulbic_pagesize">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="limitMo"
          layout="total,sizes, prev, pager, next"
          :total="pagingPageMo"
        >
        </el-pagination>
      </div>
    </div>
    <div class="public-dialog">
      <el-dialog
        title="详情"
        :visible.sync="oerderDetilsShow"
        width="50%"
        @close="detailsList = ''"
        :closeOnClickModal="false"
      >
        <div class="DetailsWater-Dialog">
          <div class="DWD-li">
            <div class="DWD-li-title">流水号</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA00 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">发单人</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA40 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">运费(每吨)</div>
            <div class="DWD-li-text">
              {{ detailsList.ORMTB470CA14 || '' }}元
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">{{detailsList.ORMTB460TP=='SL'?'直供':'含货配送'}}到货价</div>
            <div class="DWD-li-text">{{ detailsList.daohuoMoney || '' }}元</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">运费是否含税</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA70 }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">亏吨范围(吨)</div>
            <div class="DWD-li-text">
              {{ detailsList.ORMTB470CA50 || '' }}吨
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">超时取消时间(小时)</div>
            <div class="DWD-li-text">
              {{ detailsList.ORMTB470CA54 || '' }}小时
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">运费卸货净重规则</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB460CA38 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">运费结算甩零规则</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB460CA39 || '' }}</div>
          </div>

          <div class="DWD-li">
            <div class="DWD-li-title">卸货时间</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB460CA40 || '' }}</div>
          </div>
          <!-- <div class="DWD-li">
						<div class="DWD-li-title">接单人</div>
						<div class="DWD-li-text">{{detailsList.ORMTB470CA12||''}}</div>
					</div> -->
          <div class="DWD-li">
            <div class="DWD-li-title">接单车号</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA01 || '' }}</div>
          </div>
          <!-- <div class="DWD-li">
						<div class="DWD-li-title">接单方式</div>
						<div class="DWD-li-text">
							{{detailsList.ORMTB440CF00=='ZG'?'直供':detailsList.ORMTB440CF00=='LS'?'零售':detailsList.ORMTB440CF00=='QD'?'抢单':''}}
						</div>
					</div> -->
          <div class="DWD-li">
            <div class="DWD-li-title">接单时间</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA16 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">出厂结算时间</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA17 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">票号</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA48 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">完成结算时间</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CC02 || '' }}</div>
          </div>
          <!-- <div class="DWD-li">
						<div class="DWD-li-title">回执时间</div>
						<div class="DWD-li-text">{{detailsList.ORMTB440CE00||''}}</div>
					</div> -->
          <div class="DWD-li">
            <div class="DWD-li-title">原因</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA29 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">磅单审核拒绝原因</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA44 || '' }}</div>
          </div>
          <div class="DWD-li" v-if="uobj.pertb005.pertb005cb00 == 'CUS-1'">
            <div class="DWD-li-title">修改流水备注</div>
            <el-tooltip placement="top" :content="detailsList.ORMTB470CN01">
              <div class="DWD-li-text">
                {{ detailsList.ORMTB470CN01 || '' }}
              </div>
            </el-tooltip>
          </div>
		  <div class="DWD-li" v-if="uobj.pertb005.pertb005cb00 == 'CUS-1'">
		    <div class="DWD-li-title">错单原因</div>
		    <el-tooltip placement="top" :content="detailsList.ORMTB470CN18">
		      <div class="DWD-li-text">
		        {{ detailsList.ORMTB470CN18 || '' }}
		      </div>
		    </el-tooltip>
		  </div>
          <div class="DWD-table">
            <div class="DWD-table-left-title">
              <div></div>
              <div>接单</div>
              <div>出厂结算</div>
              <div>完成结算</div>
              <!-- <div>回执</div> -->
            </div>
            <div class="DWD-table-left-flex">
              <div>物料</div>
              <div>{{ detailsList.ORMTB470CA07 || '' }}</div>
              <div>{{ detailsList.ORMTB470CA19 || '' }}</div>
              <div>{{ detailsList.ORMTB470CA19 || '' }}</div>
            </div>
            <div class="DWD-table-left-flex">
              <div>单价</div>
              <div>{{ detailsList.ORMTB470CA08 || '' }}</div>
              <div>{{ detailsList.ORMTB470CA20 || '' }}</div>
              <div>{{ detailsList.ORMTB470CA20 || '' }}</div>
            </div>
            <div class="DWD-table-left-flex">
              <div>重量</div>
              <div>{{ detailsList.ORMTB470CB02 || 0 }}</div>
              <div>{{ detailsList.ORMTB470CA21 || 0 }}</div>
              <div>{{ detailsList.ORMTB470CC08 || 0 }}</div>
              <!-- <div v-else></div> -->
            </div>
            <div class="DWD-table-left-flex">
              <div>物料金额</div>
              <div>{{ detailsList.ORMTB470CA09 || 0 }}</div>
              <div>{{ detailsList.ORMTB470CA23 || 0 }}</div>
              <div>{{ detailsList.ORMTB470CA23 || 0 }}</div>
            </div>
            <div class="DWD-table-left-flex">
              <div>扣除运费</div>
              <div>{{ detailsList.ORMTB470CC06 || 0 }}</div>
              <div>{{ detailsList.ORMTB470CC06 || 0 }}</div>
              <div>{{ detailsList.ORMTB470CC06 || 0 }}</div>
              <!-- <div v-else></div> -->
            </div>
            <div class="DWD-table-left-flex">
              <div>结算运费</div>
              <div>{{ detailsList.ORMTB470CC12 || 0 }}</div>
              <div>{{ detailsList.ORMTB470CC12 || 0 }}</div>
              <div>{{ detailsList.ORMTB470CC12 || 0 }}</div>
              <!-- <div v-else></div> -->
            </div>
            <div class="DWD-table-left-flex">
              <div>额外费用</div>
              <div>{{ detailsList.ORMTB470CA72 || 0 }}</div>
              <div>{{ detailsList.ORMTB470CA72 || 0 }}</div>
              <div>{{ detailsList.ORMTB470CA72 || 0 }}</div>
              <!-- <div v-else></div> -->
            </div>
            <div
              v-if="uobj.pertb005.pertb005cb00 == 'CUS-1'"
              class="DWD-table-left-flex"
            >
              <div>管理费</div>
              <div>0</div>
              <div>0</div>
              <div>{{ detailsList.ORMTB470CA60 || 0 }}</div>
              <!-- <div v-else></div> -->
            </div>
            <div
              v-if="uobj.pertb005.pertb005cb00 == 'CUS-1'"
              class="DWD-table-left-flex"
            >
              <div>运费补贴</div>
              <div>0</div>
              <div>0</div>
              <div>{{ detailsList.ORMTB470CA71 || 0 }}</div>
              <!-- <div v-else></div> -->
            </div>
          </div>
        </div>
        <!-- div class="DetailsWater-img">
					<div class="DetailsWater-img-text">回执记录</div>
					<el-image style="width: 80px; height: 80px" :src="DetailsWaterurl"
						:preview-src-list="DetailsWatersrcList">
					</el-image>
				</div> -->
        <div
          v-if="
            detailsList.ORMTB470CA67 &&
              (detailsList.ORMTB470CA04 == '10000106' ||
                detailsList.ORMTB470CA04 == '10000107' ||
                detailsList.ORMTB440CA42 == '1')
          "
          class="DetailsWater-img"
        >
          <div class="DetailsWater-img-text">出厂磅单:</div>
          <el-image
            style="width: 80px; height: 80px"
            :src="detailsList.ORMTB470CA67"
            :preview-src-list="DetailsWeightrcList"
          >
          </el-image>
        </div>
        <div v-if="detailsList.ORMTB470CA35" class="DetailsWater-img">
          <div class="DetailsWater-img-text">卸货磅单:</div>
          <el-image
            style="width: 80px; height: 80px"
            :src="detailsList.ORMTB470CA35"
            :preview-src-list="DetailsWeightrcList"
          >
          </el-image>
        </div>
      </el-dialog>
    </div>
    <div class="public-dialog">
      <el-dialog
        title="磅单审核"
        :visible.sync="orderAuditShow"
        @close="detailsList = ''"
        width="30%"
        :closeOnClickModal="false"
      >
        <div class="DetailsWater-Dialog">
          <div class="DWD-li">
            <div class="DWD-li-title">发单人</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA40 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">实际扣款人</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB410CA04 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">运费(每吨)</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA14 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">装货地</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA05 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">卸货地</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA33 || '' }}</div>
          </div>
          <!-- 	<div class="DWD-li">
						<div class="DWD-li-title">企业名称</div>
						<div class="DWD-li-text">{{detailsList.ORMTB470CA05||''}}</div>
					</div> -->
          <!-- <div class="DWD-li">
						<div class="DWD-li-title">接单人</div>
						<div class="DWD-li-text">{{detailsList.ORMTB470CA12||''}}</div>
					</div> -->
          <div class="DWD-li">
            <div class="DWD-li-title">物料名称</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA19 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">出厂重量</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA21 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">出厂金额</div>
            <div class="DWD-li-text">
              {{
                Number(
                  detailsList.ORMTB470CA23 + detailsList.ORMTB470CA31
                ).toFixed('2')
              }}
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">接单车号</div>
            <div class="DWD-li-text">
              <!-- <div class="DWD-li-text">{{detailsList.ORMTB470CA01||''}}</div> -->
              <input
                type="text"
                v-model="detailsList.ORMTB470CA01"
                placeholder="请输入车号"
              />
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">票号</div>
            <div class="DWD-li-text">
              <input
                type="text"
                v-model="detailsList.ORMTB470CA48"
                placeholder="请输入票号"
              />
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">卸货重量</div>
            <div class="DWD-li-text">
              <!-- <div class="DWD-li-text">{{detailsList.ORMTB470CC05||''}}</div> -->
              <input
                type="number"
                v-model="detailsList.ORMTB470CC05"
                placeholder="请输入卸货重量"
              />
            </div>
          </div>
          <div class="DetailsWater-img">
            <div class="DetailsWater-img-text">磅单</div>
            <el-image
              style="width: 80px; height: 80px"
              :src="detailsList.ORMTB470CA35"
              :preview-src-list="DetailsWeightrcList"
            >
            </el-image>
          </div>
        </div>
        <div style="margin-top: 20px;text-align: center;">
          <el-button type="primary" @click="examineOrder">通过</el-button>
          <el-button type="danger" @click="updateOrder">拒绝</el-button>
        </div>
      </el-dialog>
    </div>

    <div class="public-dialog">
      <el-dialog
        title="磅单核销"
        :visible.sync="orderAuditShow1"
        @close="detailsList = ''"
        width="30%"
        :closeOnClickModal="false"
      >
        <div class="DetailsWater-Dialog">
          <div class="DWD-li">
            <div class="DWD-li-title">发单人</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA40 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">实际扣款人</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB410CA04 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">接单运费(每吨)</div>
            <!-- <div class="DWD-li-text">{{ detailsList.ORMTB470CA14 || '' }}</div> -->
            <div class="DWD-li-text">
              <input
                style="border: none;"
                @input="handInput"
                type="number"
                step="0.01"
                v-model="detailsList.ORMTB470CA14"
              />
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">发单运费(每吨)</div>
            <!-- <div class="DWD-li-text">{{ detailsList.ORMTB470CA14 || '' }}</div> -->
            <div class="DWD-li-text">
              <input
                style="border: none;"
                @input="handInput"
                type="number"
                step="0.01"
                v-model="detailsList.ORMTB470CA52"
              />
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">装货地</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA05 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">卸货地</div>
            <!-- <div class="DWD-li-text">{{ detailsList.ORMTB470CA33 || '' }}</div> -->
            <div class="DWD-li-text">
              <input
                style="border: none;"
                @input="handInput"
                type="text"
                v-model="detailsList.ORMTB470CA33"
              />
            </div>
          </div>
          <!-- 	<div class="DWD-li">
						<div class="DWD-li-title">企业名称</div>
						<div class="DWD-li-text">{{detailsList.ORMTB470CA05||''}}</div>
					</div> -->
          <!-- <div class="DWD-li">
						<div class="DWD-li-title">接单人</div>
						<div class="DWD-li-text">{{detailsList.ORMTB470CA12||''}}</div>
					</div> -->
          <div class="DWD-li">
            <div class="DWD-li-title">物料名称</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA19 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">卸货重量</div>
            <div class="DWD-li-text">
              <input
                type="number"
                v-model="detailsList.ORMTB470CC05"
                maxlength="10"
                @input="inputWeightFormat($event, 'tare', 'hx')"
              />
            </div>
          </div>
          <!-- <div class="DWD-li">
						<div class="DWD-li-title">金额</div>
						<div class="DWD-li-text">
							{{Number(detailsList.ORMTB470CA23+detailsList.ORMTB470CA31).toFixed('2')}}
						</div>
					</div> -->
          <div class="DWD-li">
            <div class="DWD-li-title">接单车号</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA01 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">运费结算方式</div>
            <div class="DWD-li-text" v-if="detailsList.ORMTB470CA58 == '1'">
              线上结算
            </div>
            <div class="DWD-li-text" v-if="detailsList.ORMTB470CA58 == '2'">
              线下结算
            </div>
            <div class="DWD-li-text" v-if="detailsList.ORMTB470CA58 == '3'">
              延迟结算
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">额外扣除司机费用</div>
            <!-- <div class="DWD-li-text">{{ detailsList.ORMTB470CA14 || '' }}</div> -->
            <div class="DWD-li-text">
              <input
                @input="handInput"
                style="border: none;"
                type="number"
                step="0.01"
                v-model="detailsList.ORMTB470CA72"
              />
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">扣除运费</div>
            <div class="DWD-li-text">{{ settlement }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">结算运费</div>
            <div class="DWD-li-text">{{ jsyfgsj }}</div>
          </div>
          <div class="DetailsWater-img">
            <div class="DetailsWater-img-text">磅单</div>
            <el-image
              style="width: 80px; height: 80px"
              :src="detailsList.ORMTB470CA35"
              :preview-src-list="DetailsWeightrcList"
            >
            </el-image>
          </div>
        </div>
        <div style="margin-top: 20px;text-align: center;">
          <el-button type="primary" @click="examineWriteOffOrder"
            >确定</el-button
          >
          <!-- <el-button type="danger" @click="updateOrder">拒绝</el-button> -->
        </div>
      </el-dialog>
    </div>

    <div class="public-dialog">
      <el-dialog
        title="上传磅单"
        :visible.sync="orderAuditShow2"
        @close="detailsList = ''"
        width="30%"
        :closeOnClickModal="false"
      >
        <div class="DetailsWater-Dialog">
          <div class="DWD-li">
            <div class="DWD-li-title">发单人</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA40 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">运费(每吨)</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA14 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">装货地</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA05 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">卸货地</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA33 || '' }}</div>
          </div>
          <!-- <div class="DWD-li">
						<div class="DWD-li-title">接单人</div>
						<div class="DWD-li-text">{{detailsList.ORMTB470CA12||''}}</div>
					</div> -->
          <div class="DWD-li">
            <div class="DWD-li-title">接单车号</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA01 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">物料名称</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA19 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">接单重量</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CB02 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">出厂重量</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA21 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">卸货重量</div>
            <div class="DWD-li-text">
              <input
                type="number"
                v-model="detailsList.ORMTB470CC05"
                maxlength="10"
                @input="inputWeightFormat($event, 'tare')"
              />
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">票号</div>
            <div class="DWD-li-text">
              <input type="text" v-model="detailsList.ph" />
            </div>
          </div>
          <!-- <div class="DWD-li">
						<div class="DWD-li-title">金额</div>
						<div class="DWD-li-text">
							{{Number(detailsList.ORMTB470CA23+detailsList.ORMTB470CA31).toFixed('2')}}
						</div>
					</div> -->

          <div class="DetailsWater-img">
            <div class="DetailsWater-img-text" style="font-size: 20px;">
              磅单
            </div>

            <!-- :before-upload="beforeAvatarUpload" -->
            <el-upload
              action="#"
              class="upload-demo"
              ref="upload"
              style="padding-top: 10px;font-size: 15px;"
              :multiple="false"
              list-type="picture"
              :http-request="UploadImage"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :limit="1"
              :on-change="handleChange"
              :on-exceed="handleExceed"
              :file-list="formData.fileList"
            >
              <i class="el-icon-upload" style=""></i>
              <div style="display: inline-block;padding-left: 10px;">
                <em>点击上传</em>
              </div>
            </el-upload>
            <div
              class="demo-image__preview"
              v-if="dialogVisible == true"
              style="padding-top: 20px;"
            >
              <el-image
                style="width: 100px; height: 100px"
                :src="dialogImageUrl"
                :preview-src-list="bdurlList"
              >
              </el-image>
              <div class="">
                点击图片查看大图
              </div>
            </div>
            <!-- <el-dialog :modal="false" :visible.sync="dialogVisible">
							<img width="100%" :src="dialogImageUrl" alt="" />
							
							<div class="demo-image__preview">
							  <el-image v-if="dialogVisible == true" 
							    style="width: 100px; height: 100px"
							    :src="formData.fileList" 
							    :preview-src-list="formData.fileList">
							  </el-image>
							</div>
						</el-dialog> -->

            <!-- <el-image style="width: 80px; height: 80px" :src="detailsList.ORMTB470CA35"
							:preview-src-list="DetailsWeightrcList">
						</el-image> -->
          </div>
        </div>
        <div style="margin-top: 20px;text-align: center;">
          <el-button type="primary" @click="examinebdOffOrder">提交</el-button>
          <!-- <el-button type="danger" @click="updateOrder">拒绝</el-button> -->
        </div>
      </el-dialog>
    </div>

    <div class="public-dialog">
      <el-dialog
        title="审核"
        :visible.sync="isorderAuditShow"
        @close=";(detailsList = ''), (isorderAuditText = '')"
        width="30%"
        :closeOnClickModal="false"
      >
        <div class="DetailsWater-Dialog">
          <div class="DWD-li">
            <div class="DWD-li-title">发单人</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA40 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">装货地</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA05 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">卸货地</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA33 || '' }}</div>
          </div>
          <!-- 	<div class="DWD-li">
						<div class="DWD-li-title">企业名称</div>
						<div class="DWD-li-text">{{detailsList.ORMTB470CA05||''}}</div>
					</div> -->
          <!-- <div class="DWD-li">
						<div class="DWD-li-title">接单人</div>
						<div class="DWD-li-text">{{detailsList.ORMTB470CA12||''}}</div>
					</div> -->
          <div class="DWD-li">
            <div class="DWD-li-title">物料名称</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA07 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">接单重量</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CB02 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">物料金额</div>
            <div v-if="" class="DWD-li-text">
              {{ detailsList.ORMTB470CA09 || '' }}
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">运费</div>
            <div v-if="" class="DWD-li-text">
              {{ detailsList.ORMTB470CA10 || '' }}
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">接单车号</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA01 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">发起取消者</div>
            <div class="DWD-li-text" v-if="detailsList.ORMTB470CA41 == '0'">
              接单人
            </div>
            <div class="DWD-li-text" v-if="detailsList.ORMTB470CA41 == '1'">
              发单人
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">审核说明</div>
            <div class="DWD-li-text">
              <input type="text" v-model="isorderAuditText" maxlength="20" />
            </div>
          </div>
        </div>
        <div style="margin-top: 20px;text-align: center;">
          <el-button type="primary" @click="isorderAuditServe(1)"
            >通过</el-button
          >
          <el-button type="danger" @click="isorderAuditServe(2)"
            >拒绝</el-button
          >
        </div>
      </el-dialog>
    </div>
    <div class="public-dialog">
      <el-dialog
        title="详情"
        :visible.sync="returnReceiptShow"
        @close="detailsList = ''"
        width="30%"
        :closeOnClickModal="false"
      >
        <div class="CustomerfillingDig-tab">
          <div class="CustomerfillingDig-tab-li">
            <div class="CustomerfillingDig-tab-li-text">车牌号：</div>
            <div class="CustomerfillingDig-tab-li-ipt">
              {{ detailsList.ORMTB440CA01 || '' }}
            </div>
            <div class="CustomerfillingDig-tab-li-b"></div>
          </div>
          <div class="CustomerfillingDig-tab-li">
            <div class="CustomerfillingDig-tab-li-text">回执物料：</div>
            <div class="CustomerfillingDig-tab-li-ipt">
              {{ detailsList.ORMTB440CA07 || '' }}
            </div>
            <div class="CustomerfillingDig-tab-li-b"></div>
          </div>
          <div class="CustomerfillingDig-tab-li">
            <div class="CustomerfillingDig-tab-li-text">回执重量：</div>
            <div class="CustomerfillingDig-tab-li-ipt">
              <input
                ref="topWeight"
                type="text"
                v-model="detailsList.ORMTB440CE02"
                maxlength="10"
                @input="topWeightInput"
                @change="topWeightChange"
              />
            </div>
            <div class="CustomerfillingDig-tab-li-b">*必填*</div>
          </div>
          <div class="CustomerfillingDig-tab-li">
            <div class="CustomerfillingDig-tab-li-text">回执运费单价：</div>
            <div class="CustomerfillingDig-tab-li-ipt">
              <input
                ref="topMoney"
                type="text"
                v-model="detailsList.ORMTB440CA21"
                maxlength="10"
                @input="topMoneyInput"
                @change="topMoneyChange"
              />
            </div>
            <div class="CustomerfillingDig-tab-li-b">*必填*</div>
          </div>
        </div>
        <div class="DetailsWater-img">
          <div class="DetailsWater-img-text">回执记录</div>
          <el-image
            style="width: 80px; height: 80px"
            :src="DetailsWaterurl"
            :preview-src-list="DetailsWatersrcList"
          >
          </el-image>
        </div>
        <div style="margin-top: 20px;text-align: center;">
          <el-button type="primary" @click="returnReceiptserve">确定</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="public-dialog">
      <el-dialog
        title="二维码详情"
        :visible.sync="ewmDetilsShow"
        width="35%"
        @close="ewmdetailsList = ''"
        :closeOnClickModal="false"
      >
        <div class="DetailsWater-img" style="text-align: center;">
          <!-- <div class="DetailsWater-img-text">二维码</div> -->
          <el-image
            style="width: 250px; height: 250px"
            :src="ewmdetailsList.ORMTB440CA22Img"
            :preview-src-list="ewmDetails"
          >
            >
          </el-image>
        </div>

        <div class="DetailsWater-Dialog">
          <div class="DWD-li">
            <div class="DWD-li-title">车牌号</div>
            <div class="DWD-li-text">
              {{ ewmdetailsList.ORMTB470CA01 || '' }}
            </div>
          </div>
          <!-- <div class="DWD-li">
						<div class="DWD-li-title">接单人</div>
						<div class="DWD-li-text">{{ewmdetailsList.ORMTB470CA12||''}}</div>
					</div> -->
          <div class="DWD-li">
            <div class="DWD-li-title">订单编号</div>
            <div class="DWD-li-text">
              {{ ewmdetailsList.ORMTB470CA00 || '' }}
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">接单时间</div>
            <div class="DWD-li-text">
              {{ ewmdetailsList.ORMTB470CA16 || '' }}
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">企业</div>
            <div class="DWD-li-text">
              {{ ewmdetailsList.ORMTB470CA05 || '' }}
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">物料</div>
            <div class="DWD-li-text">
              {{ ewmdetailsList.ORMTB470CA07 || '' }}
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">接单重量</div>
            <div class="DWD-li-text">
              {{ ewmdetailsList.ORMTB470CB02 || '' }}
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="public-dialog">
      <el-dialog
        title="出厂完成订单"
        :visible.sync="inputWeightShow"
        @close="inputWeightClose"
        width="50%"
        :closeOnClickModal="false"
      >
        <div class="CustomerfillingDig-tab">
          <div class="CustomerfillingDig-tab-li">
            <div class="CustomerfillingDig-tab-li-text">厂家：</div>
            <div class="CustomerfillingDig-tab-li-ipt">
              <input type="text" v-model="detailsList.ORMTB470CA05" disabled />
            </div>
            <div class="CustomerfillingDig-tab-li-b"></div>
          </div>
          <div class="CustomerfillingDig-tab-li">
            <div class="CustomerfillingDig-tab-li-text">客户：</div>
            <div class="CustomerfillingDig-tab-li-ipt">
              <input type="text" v-model="detailsList.ORMTB410CA04" disabled />
            </div>
            <div class="CustomerfillingDig-tab-li-b"></div>
          </div>

          <div class="CustomerfillingDig-tab-li">
            <div class="CustomerfillingDig-tab-li-text">派单物料：</div>
            <div class="CustomerfillingDig-tab-li-ipt">
              <!-- <input type="text" v-model="detailsList.ORMTB440CA07" disabled> -->
              <div class="" style="line-height: initial; padding-top: 10px;">
                <el-select
                  v-model="materialValue"
                  placeholder="请选择"
                  @change="materialChange"
                >
                  <el-option
                    v-for="item in materialList"
                    :key="item.value"
                    :label="item.lable"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="CustomerfillingDig-tab-li-b"></div>
          </div>
          <div class="CustomerfillingDig-tab-li">
            <div class="CustomerfillingDig-tab-li-text">单价：</div>
            <div class="CustomerfillingDig-tab-li-ipt">
              <input
                @input="inputWeightFormat1($event, 'price')"
                type="number"
                v-model="weightOpt.price"
                maxlength="10"
              />
            </div>
            <div class="CustomerfillingDig-tab-li-b"></div>
          </div>
          <!-- <div class="CustomerfillingDig-tab-li">
						<div class="CustomerfillingDig-tab-li-text">毛重：</div>
						<div class="CustomerfillingDig-tab-li-ipt">
							<input type="number" v-model="weightOpt.tare" maxlength="10"
								@input="inputWeightFormat($event,'tare')">
						</div>
						<div class="CustomerfillingDig-tab-li-b"></div>
					</div>
					<div class="CustomerfillingDig-tab-li">
						<div class="CustomerfillingDig-tab-li-text">皮重：</div>
						<div class="CustomerfillingDig-tab-li-ipt">
							<input type="number" v-model="weightOpt.gross" maxlength="10"
								@input="inputWeightFormat($event,'gross')">
						</div>
						<div class="CustomerfillingDig-tab-li-b"></div>
					</div> -->
          <div class="CustomerfillingDig-tab-li">
            <div class="CustomerfillingDig-tab-li-text">净重：</div>
            <div class="CustomerfillingDig-tab-li-ipt">
              <input
                type="text"
                @input="inputWeightFormat($event, 'tare')"
                v-model="weightOpt.tare"
                maxlength="10"
              />
            </div>
            <div class="CustomerfillingDig-tab-li-b"></div>
          </div>
          <div class="CustomerfillingDig-tab-li">
            <div class="CustomerfillingDig-tab-li-text">结算金额：</div>
            <div class="CustomerfillingDig-tab-li-ipt">
              <input
                type="text"
                v-model="weightOpt.jsprice"
                maxlength="100"
                :disabled="dcjsiput"
              />
            </div>
            <div class="CustomerfillingDig-tab-li-b"></div>
          </div>

          <div
            class="Customer-upload-bd"
            v-if="
              detailsList.ORMTB470CA04 == '10000106' ||
                detailsList.ORMTB470CA04 == '10000107' ||
                detailsList.ORMTB470CA66 == '1'
            "
          >
            <el-upload
              action=""
              list-type="picture"
              :class="{ disabled: uploadDisabled }"
              :auto-upload="false"
              :limit="1"
              ref="upload"
              :on-success="handleChangeSuccess"
              :on-change="handleChangezjccbd"
              :on-preview="handlePictureCardPreviewzjccbd"
              :on-remove="handleRemovezjccbd"
              :file-list="fileListccbd"
            >
              <el-button size="small" type="primary">点击上传磅单</el-button>
            </el-upload>
            <!-- 预览图片 -->
            <el-dialog :visible.sync="dialogVisibleimg" append-to-body>
              <img width="80%" :src="dialogImageUrlzjccbd" alt="" />
            </el-dialog>
          </div>
        </div>
        <div style="margin-top: 20px;text-align: center;">
          <el-button type="primary" @click="inputWeightConfirm">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import { createLogger } from 'vuex'
import debounce from '../../api/debounce'
export default {
  data() {
    return {
      weightOpt: {
        tare: '',
        gross: '',
        jsprice: '',
        price: '',
      },
      loadingBut: false,
      confirmTxt: 0,
      inputWeightShow: false, // 输入磅单信息弹窗
      isorderAuditText: '',
      oerderDetilsShow: false,
      orderAuditShow: false,
      orderAuditShow1: false,
      orderAuditShow2: false,
      isorderAuditShow: false,
      returnReceiptShow: false,
      uobj: this.$store.state.uobj, //登陆缓存--用户信息
      date: [], //日期
      startTime: '',
      endTime: '',
      dateNowDayActive: false,
      dateYesterdayActive: false,
      dateNowMonthActive: false,
      dateLastMonthActive: false,
      twolevelUserLogin: true,
      timeIndex: 0, //判断第几次切换当月时间
      sameMonthTime: '', //目前月份
      currentMonthTime: '', //目前月份--上月+1
      tableData: [],
      ORMTB440CA00: '',
      ORMTB470CA12: '',
      ORMTB470CA40: '',
      ORMTB410CA04: '',
      materialOptions: [],
      materialTypeValue: '',
      customerOptions: [
        {
          ORMTB410ID: '',
          ORMTB410CA00: '全部',
        },
      ],
      carNum: '',
      materielMo: '',
      materielOptions: [
        {
          SETTB109CA00: '全部',
          SETTB109ID: '',
        },
      ],
      // 结算方式
      dataStatusOperation0: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '1',
          label: '线上结算',
        },
        {
          value: '2',
          label: '线下结算',
        },
      ],

      // 状态
      dataStatusOperation: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '0',
          label: '已接单',
        },
        {
          value: '1',
          label: '提货中',
        },
        {
          value: '2',
          label: '已出厂',
        },
        {
          value: '3',
          label: '待审核磅单',
        },
        {
          value: '4',
          label: '待完成磅单',
        },
        {
          value: '5',
          label: '完成',
        },
        {
          value: '-1',
          label: '取消',
        },
        {
          value: '-2',
          label: '取消申请',
        },
      ],
      jscc: 0,
      jsje: 0,
      jszl: 0,
      jsyf: 0,
      pdcc: 0,
      pdje: 0,
      pdzl: 0,
      pdyf: 0,
      wccc: 0,
      wcje: 0,
      wcyf: 0,
      jsyfsjtj: 0,
      glf: 0,
      wczl: 0,
      // 查询
      customerMo: '', //客户--查询
      SETTB122CA07: '', //数据状态
      ORMTB470CA58: '', //运费结算状态
      billOperationAdd: false,
      enterpriseTwoOptionList: [
        {
          SETTB109CA00: '全部',
          SETTB109ID: '',
        },
      ], //二级企业下拉框--新增
      enterpriseTwo: '', //二级企业
      carNumber: '', //车牌号
      pageMo: 1, //默认列表页码
      limitMo: 10, //每页的条数
      pagingPageMo: 0, //分页--数据列表共有的条数
      currentPage: 1, //设置当前页默认为1
      // 列设置
      checkAll: true,
      checkedCities: [
        '派单时间',
        '派单编号',
        '企业名称',
        '客户名称',
        '车牌号',
        '订单物料',
        '出厂物料',
        '重量',
        '完成状态',
        '申请状态',
      ],
      cities: [
        '派单时间',
        '派单编号',
        '企业名称',
        '客户名称',
        '车牌号',
        '订单物料',
        '出厂物料',
        '重量',
        '完成状态',
        '申请状态',
      ],
      isIndeterminate: false,
      // 详情
      billOperationDetails: false,
      detailsList: '', //详情列表
      tableHeadList: [
        // {
        // 	prop: 'ORMTB440CA19',
        // 	label: '派单时间',
        // 	width: 110
        // },
        // {
        // 	prop: 'ORMTB440CA00',
        // 	label: '派单编号',
        // 	width: 130
        // },
        // {
        // 	prop: 'ORMTB440CA05',
        // 	label: '企业名称',
        // },
        // {
        // 	prop: 'ORMTB440CA03',
        // 	label: '客户名称',
        // },

        {
          prop: 'ORMTB470CA01',
          label: '接单车号',
          width: 100,
        },
        {
          prop: 'ORMTB470CA07',
          label: '订单物料',
          width: 100,
        },
        {
          prop: 'ORMTB470CA19',
          label: '出厂物料',
          width: 100,
        },
        {
          prop: 'ORMTB470CB02',
          label: '接单重量',
          width: 100,
        },
        {
          prop: 'ORMTB470CA17',
          label: '出厂结算时间',
          width: 120,
        },
        {
          prop: 'ORMTB470CC02',
          label: '完成结算时间',
          width: 120,
        },
        // {
        // 	prop: 'ORMTB470CA23',
        // 	label: '出厂结算金额',
        // 	width: 120
        // },
        // {
        // 	prop: 'ORMTB470CA23',
        // 	label: '完成结算金额',
        // 	width: 120
        // },
        // {
        // 	prop: 'ORMTB470CA24',
        // 	label: '流水号',
        // 	width: 130
        // }
        // {
        // 	prop: 'ORMTB440CF01text',
        // 	label: '完成状态',
        // 	width: 100
        // },
        // {
        // 	prop: 'auditText',
        // 	label: '申请状态',
        // 	width: 100
        // }
      ],
      tableHeadListInit: [
        {
          prop: 'ORMTB470CA16',
          label: '派单时间',
        },
        {
          prop: 'ORMTB470CA00',
          label: '派单编号',
        },
        {
          prop: 'ORMTB470CA05',
          label: '企业名称',
        },
        {
          prop: 'ORMTB470CA12',
          label: '客户名称',
        },

        {
          prop: 'ORMTB470CA01',
          label: '车牌号',
        },
        {
          prop: 'ORMTB470CA07',
          label: '订单物料',
        },
        {
          prop: 'ORMTB440CC02',
          label: '完成物料',
        },
        {
          prop: 'ORMTB440CA10',
          label: '重量',
        },
        {
          prop: 'ORMTB440CF01text',
          label: '完成状态',
        },
        {
          prop: 'auditText',
          label: '申请状态',
        },
      ],
      // 离线订单
      orlxOrdeOptions: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '1',
          label: '是',
        },
      ],
      lxorde: '',
      examineObj: {},
      isRefresh: true,
      isRefreshSetInterval: '',
      // quanpDisabled: false,
      // 历史缓存
      currentUrl: this.$route.path,
      historyInfo: '',
      // 时间限制
      // 限制开始日期不能超过当前日期
      startDateDisabled: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
      solelist: [],
      DetailsWaterurl: '',
      DetailsWatersrcList: [],
      DetailsWeightrcList: [],
      materialList: [],
      materialValue: '',
      listTick: null, // 列表刷新定时器
      timeType: '1',
      ewmDetilsShow: false,
      ewmDetails: [],
      ewmdetailsList: '', //二维码详情
      formData: {
        name: '',
        brand: '',
        unit: '',
        category: [],
        desc: '',
        fileList: [],
        img: [],
		fileId:''
      },
      isname: true,
      dialogImageUrl: undefined,
      videoFlag: false,
      uploadFileUrl: process.env.VUE_APP_BASE_API + '/system/image/uploadFile', // 上传的图片服务器地址
      dialogVisible: false,
      bdurlList: [],
      dcjsiput: true,

      /*/ 自建厂家出厂榜单data START/*/
      fileListccbd: [],
      dialogVisibleimg: false,
      formdata: new FormData(),
      dialogImageUrlzjccbd: '',
      addimg: [],
      removeimg: [],
      ruleForm: {
        csAvatar: '',
		fileId:''
      },
      orXgOrdeOptions: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '1',
          label: '是',
        },
      ],
      xgorde: '',
      orderId: '', //订单
      settlement: '', //扣除发单人运费
      jsyfgsj: '', //结算给司机运费
      /*/ 自建厂家出厂榜单data END/*/

      // headers: {
      //  Authorization: "Bearer " + getToken(),
      // }
      newOrderId: '', //订单ID
      dcmore: '',
	  
	  //错单
	  orCdOrdeOptions: [
	    {
	      value: '',
	      label: '全部',
	    },
	    {
	      value: '1',
	      label: '是',
	    },
	  ],
	  cdorde:'',
	  orderSource:'',//订单出处
	  orderSourceOpenOptions: [
	  		  {
	  		    value: '',
	  		    label: '全部'
	  		  },
	    {
	      value: 0,
	      label: '客户'
	    },
	    {
	      value: 1,
	      label: '平台'
	    }
	  ],
    }
  },
  watch: {
    weightOpt: {
      handler(val) {
        if ((val.tare || val.tare === 0) && (val.price || val.price === 0)) {
          let tare = parseFloat(val.tare)

          // let gross = parseFloat(val.gross)
          // debounce(this.getSettlementAmount, 500)
          // this.detailsList.ORMTB470CA21 = (tare - gross).toFixed(2)

          if (this.weightOpt.tare >= 0) {
            debounce(this.getSettlementAmount, 500)
          }
          // else {

          // }
        } else {
          // this.detailsList.ORMTB470CA21 = ''
          this.weightOpt.jsprice = ''
        }
      },
      deep: true,
    },
    // 'detailsList.ORMTB440CA04'() {
    //     this.getSelectMaterial()
    // }
  },
  created() {
    var list = ''
    list = this.$store.state.solelist
    // 赋值，缓存销毁
    this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
    sessionStorage.removeItem(this.currentUrl)
    if (this.historyInfo != null && this.historyInfo != '') {
      this.init()
    }
    // else {
    // 	this.getNowDay();
    // }
    var path = this.$route.path
    // console.log(path)
    if (path === '/SalesFreightOrder') {
      path = '/Home' + path
    }
    this.solelist = this.$baseAPI.querSoleList(list, path) //获取权限列表
  },
  mounted() {
    if (this.historyInfo == null && this.$route.query.mark == null) {
      this.getNowDay()
      this.startTime = this.date[0]
      this.endTime = this.date[1]
      this.dateNowDayActive = true
    }

    this.optionLists()
    this.enterprise0ptions()
    this.listTick = setInterval(() => {
      this.queryClick()
    }, 1000 * 60)
    // console.log(this.$store.state.uobj)
  },
  // 存储数据
  beforeDestroy() {
    clearInterval(this.listTick)
    this.listTick = null
    this.startTime = this.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(this.date[0]))
    this.endTime = this.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(this.date[1]))
    var obj = {
      startTime: this.startTime,
      endTime: this.endTime, //开始时间
      ORMTB440CA02: this.ORMTB440CA02, //客户id
      ORMTB400CA03: this.ORMTB400CA03, //客户名称
      ORMTB440CA04: this.ORMTB440CA04, //客户名称
      ORMTB440CA06: this.ORMTB440CA06, //二级企业id
      ORMTB440CF01: this.ORMTB440CF01, //二级企业名称
      ORMTB440CA00: this.ORMTB440CA00, //数据状态--转换
      ORMTB440CA01: this.ORMTB440CA01, //数据状态--名字
      currentPage: this.currentPage, //当前页数
      pageMo: this.pageMo, //页码
      limitMo: this.limitMo, //每页条数
      dateNowDayActive: this.dateNowDayActive,
      dateYesterdayActive: this.dateYesterdayActive,
      dateNowMonthActive: this.dateNowMonthActive,
      dateLastMonthActive: this.dateLastMonthActive,
      ORMTB440CA00: this.ORMTB440CA00,
    }
    sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
  },
  computed: {
    uploadDisabled: function() {
      // console.log(this.ruleForm.csAvatar)
      return this.ruleForm.csAvatar != ''
    },
  },
  methods: {
    handInput() {
      this.getFree()
    },
    //获取结算运费
    getFree() {
      var dataObj = {
        ORMTB470ID: this.examineObj.ORMTB470ID,
        ORMTB470CC05: this.detailsList.ORMTB470CC05,
        ORMTB470CA14: this.detailsList.ORMTB470CA14,
        ORMTB470CA33: this.detailsList.ORMTB470CA33,
        ORMTB470CA72: this.detailsList.ORMTB470CA72,
        ORMTB470CA52: this.detailsList.ORMTB470CA52 || 0,
      }
      this.axios.post('/request/yfBeforePay', dataObj).then(res => {
        if (res.data.code == 200) {
          console.log(res, 'oooo')
          this.settlement = res.data.data.ORMTB470CC06
          this.jsyfgsj = res.data.data.ORMTB470CC12
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      })
    },
    cancelPlan(row) {
      //取消要货计划
      this.axios
        .post('orm/ormtb470/cancelGoodsPlan', { ORMTB470ID: row.ORMTB470ID })
        .then(res => {
          if (res.data.code == 200) {
            console.log(res)
            this.$message({
              message: '成功',
              type: 'success',
            })
            this.pageList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
    },
    // 值改变 重新获取结算金额
    async materialChange(val) {
      if (val == this.detailsList.ORMTB470CA18) {
        this.weightOpt.price = this.detailsList.ORMTB470CA08
      } else {
        await this.queryMaterialPrice(val)
      }
      this.getSettlementAmount() //获取结算金额
    },
    // 根据物料id 查询单价
    async queryMaterialPrice(ORMTB440CC01) {
      let url = '/orm/ormtb440/unitPriceAuto'
      let params = {
        ORMTB440CC01, // 结算物料id
        ORMTB440CA02: this.detailsList.ORMTB410CA01, //客户id
        ORMTB440CA04: this.detailsList.ORMTB470CA04, // 二级企业ID
        ORMTB440ID: this.newOrderId,
      }
      params = qs.stringify(params)
      let header = {
        'Content-Type': 'application/x-www-form-urlencoded',
      }
      let res = await this.axios.post(url, params, {
        header,
      })
      if (res.data.code === 200) {
        this.weightOpt.price = res.data.data
      }
    },
    //删除图片
    handleRemove(file, fileList) {
      console.log(file)
      //   判断是否是正确格式图片才能执行删除
      if (file && file.status === 'success') {
        let Pics = this.formData.fileList
        Pics.forEach((item, index) => {
          if (file.name == item.name) {
            Pics.splice(index, 1)
          }
        })
      }
      this.dialogImageUrl = ''
	  this.formData.fileId = ''
      this.bdurlList = []
      this.dialogVisible = false
      //   console.log(this.formData.fileList);
    },
    //查看图片
    handlePictureCardPreview(file) {
      // this.dialogImageUrl = file.url;
      console.log(file)
      // this.dialogVisible = true;
    },
    handleChange(file, fileList) {
      console.log(fileList)
      //   console.log(file);
    },

    getocrFun(data) {
      let loading = this.$loading({
        lock: true,
        text: '识别中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        url: data,
      }
      var url = '/orm/ormtb470/getOcr'

      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            console.log(res)
            // this.$message({
            // 	message: '成功',
            // 	type: 'success'
            // });
            // this.pageList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    //   手动上传
    //   submitUpload() {
    //     console.log(this.$refs.upload)
    //     this.$refs.upload.submit();
    //   },
    // 在使用http-request方法的时候，调用的事件必须以param为参数，通过param.file取得文件。
    UploadImage(param) {
      const formData = new FormData()
      formData.append('file', param.file)
      // formData.append('ORMTB470CA00', this.ORMTB470CA00)
      let loading = this.$loading({
        lock: true,
        text: '上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var url = '/system/uploadBD'

      this.axios
        .post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            console.log(res)
            this.$message({
              message: res.data.data.message,
              type: 'success',
            })
            this.getocrFun(res.data.data.bdurl)
            this.formData.fileList.push({
              name: param.file.name,
              url: res.data.data.bdurl,
              uid: param.file.uid,
            })
            // this.pageList()
            this.dialogImageUrl = res.data.data.bdurl
			this.formData.fileId = res.data.data.fileId
            this.bdurlList.push(res.data.data.bdurl)
            this.dialogVisible = true
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })

      
    },
   
    //控制上传数量提示
    handleExceed(files, fileList) {
      this.$message.warning(`最多上传1个文件`)
    },

    /*/ 自建厂家出厂上传磅单START/*/
    handleChangeSuccess() {},

    handleChangezjccbd(file, fileList) {
      const isJPG =
        file.raw.type === 'image/jpeg' || file.raw.type === 'image/png'
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 、png 格式!')
        fileList.splice(-1, 1) //移除错误文件
        return false
      }
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!')
        fileList.splice(-1, 1)
        return false
      }

      this.addimg = fileList[0].raw
      // this.ruleForm.csAvatar = this.addimg;
      // console.log(file)
      // console.log(fileList)
      this.fileListccbd = []
      let data = new FormData()
      data.append('file', this.addimg)
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var url = '/system/uploadBD'
      this.axios
        .post(url, data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            // console.log(res)
            this.ruleForm.csAvatar = res.data.data.bdurl
			this.ruleForm.fileId = res.data.data.fileId
            this.fileListccbd = fileList
            // console.log(this.fileList)
            this.$message({
              message: res.data.data.message,
              type: 'success',
            })
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },

    // 删除活动展示照片
    handleRemovezjccbd(file, fileList) {
      // console.log(fileList)
      var index1 = this.ruleForm.csAvatar.lastIndexOf('2022', '2023')
      var imgdel = this.ruleForm.csAvatar.substring(index1)
      // console.log(imgdel)
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var url = '/orm/ormtb440/deleteFile'
      var postData = {
        fileName: imgdel,
      }
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            // console.log(res)
            this.ruleForm.csAvatar = ''
			this.ruleForm.fileId = ''
            this.formdata = new FormData()
            this.$message({
              message: res.data.message,
              type: 'success',
            })
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    // 活动展示照片预览
    handlePictureCardPreviewzjccbd(file) {
      this.dialogImageUrlzjccbd = file.url
      this.dialogVisibleimg = true
    },

    // 渲染编辑获取id
    applyzjccbd() {
      this.fileListccbd = [
        {
          url: '',
        },
      ] //这里是踩坑的点，必须写
      this.fileListccbd[0].url = res.data.csAvatar //这里是调用接口获取到的值 res.data.csAvatar，赋值就可以回显了
      //this.fileList[0].url 做的是单张图片回显，多张图片回显可以去掉[0]
    },

    /*/ 自建厂家出厂上传磅单END/*/

	cdclDetailsClick(row){//错单描述
			 var url = '/orm/ormtb470/updateCN17ById'
			      this.$prompt('请输入错单原因', '提示', {
			        confirmButtonText: '确定',
			        cancelButtonText: '取消',
			        inputPattern: /^.{1,}$/,
			        inputErrorMessage: '原因不能为空',
			      }).then(({ value }) => {
			        var postData = {
			          ORMTB470ID: row.ORMTB470ID,
			          ORMTB470CN18: value, //错单描述
			        }
			        let loading = this.$loading({
			          lock: true,
			          text: '请求中...',
			          spinner: 'el-icon-loading',
			          background: 'rgba(0, 0, 0, 0.5)',
			        })
			        this.axios
			          .post(url, postData)
			          .then(res => {
			            if (res.data.code == 200) {
			              this.pageList()
			              this.$message({
			                type: 'success',
			                message: res.data.message,
			              })
			            } else {
			              this.$message({
			                message: res.data.message,
			                type: 'error',
			              })
			            }
			            loading.close()
			          })
			          .catch(() => {
			            loading.close()
			          })
			      })
	},

    // 获取派单物料列表
    getSelectMaterial(row) {
      var postData = {
        SETTB99ID: row.ORMTB470CA04,
      }
      this.materialList = []
      postData = qs.stringify(postData)
      var url = '/set/settb109/select_material'
      this.axios
        .post(url, postData, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then(res => {
          if (res.data.code == 200) {
            this.materialList = res.data.data
            // this.materialValue = this.detailsList.ORMTB440CC01
            if (this.detailsList.ORMTB470CA18) {
              this.materialValue = this.detailsList.ORMTB470CA18
            } else {
              this.materialValue = this.detailsList.ORMTB470CA06
              // console.log(this.detailsList)
              this.queryMaterialPrice(this.materialValue)
            }
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    //初始化数据
    init() {
      this.startTime = this.historyInfo.startTime
      this.endTime = this.historyInfo.endTime
      this.date = [this.startTime, this.endTime]
      this.ORMTB440CA02 = this.historyInfo.ORMTB440CA02
      this.ORMTB400CA03 = this.historyInfo.ORMTB400CA03
      this.ORMTB440CA04 = this.historyInfo.ORMTB440CA04
      this.ORMTB440CA06 = this.historyInfo.ORMTB440CA06
      this.ORMTB440CF01 = this.historyInfo.ORMTB440CF01
      this.ORMTB440CA00 = this.historyInfo.ORMTB440CA00
      this.ORMTB440CA01 = this.historyInfo.ORMTB440CA01
      this.currentPage = this.historyInfo.currentPage
      this.pageMo = this.historyInfo.pageMo
      this.limitMo = this.historyInfo.limitMo
      this.dateNowDayActive = this.historyInfo.dateNowDayActive
      this.dateYesterdayActive = this.historyInfo.dateYesterdayActive
      this.dateNowMonthActive = this.historyInfo.dateNowMonthActive
      this.dateLastMonthActive = this.historyInfo.dateLastMonthActive
      this.ORMTB440CA00 = this.historyInfo.ORMTB440CA00
    },
    // 导出
    exports() {
      // console.log(this.uobj)
      let token = sessionStorage.getItem('token')
      if (this.uobj.pertb005.pertb005cb00 == 'CUS-2') {
        this.customerMo = this.uobj.ormtb410.ORMTB410ID //一级企业id
      }
      var startTime = this.date[0] //开始时间
      var endTime = this.date[1] //结束时间
      var ORMTB440CA02 = this.customerMo //二级客户ID
      var ORMTB400CA03 = 1002 //一级客户代码
      var ORMTB440CA04 = this.enterpriseTwo //二级企业ID
      var ORMTB440CA06 = this.materielMo //物料ID
      var ORMTB440CF01 = this.SETTB122CA07 //状态
      var ORMTB440CA00 = this.ORMTB440CA00 //订单号
      var ORMTB440CA01 = this.carNumber //车牌号
      var ORMTB470CA40 = this.ORMTB470CA40 //发单人
      var ORMTB410CA04 = this.ORMTB410CA04 //货主
      var ORMTB470CA58 = this.ORMTB470CA58 //运费结算方式
      var timeType = this.timeType //
	  var source = this.orderSource//订单出处
      var url =
        this.axios.defaults.baseURL +
        '/exc/toExcel/ormtb470toExcle?startTime=' +
        startTime +
        '&endTime=' +
        endTime +
        '&token=' +
        token +
        '&ORMTB440CA02=' +
        ORMTB440CA02 +
        '&ORMTB400CA03=' +
        ORMTB400CA03 +
        '&ORMTB440CA04=' +
        ORMTB440CA04 +
        '&ORMTB440CA06=' +
        ORMTB440CA06 +
        '&ORMTB440CF01=' +
        ORMTB440CF01 +
        '&ORMTB440CA00=' +
        ORMTB440CA00 +
        '&ORMTB440CA01=' +
        ORMTB440CA01 +
        '&ORMTB470CA40=' +
        ORMTB470CA40 +
        '&ORMTB410CA04=' +
        ORMTB410CA04 +
        '&ORMTB470CA58=' +
        ORMTB470CA58 +'&source='+source+
        '&timeType=' +
        timeType
      window.location.href = url

      this.loadingBut = true
      var timer = null //倒计时
      this.confirmTxt = 30 - 1
      timer = setInterval(() => {
        if (this.confirmTxt === 0) {
          this.confirmTxt = ''
          this.loadingBut = false
          clearInterval(timer)
        } else {
          this.confirmTxt--
        }
      }, 1000)
    },
    topWeightInput() {
      this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(
        /[^\d.]/g,
        ''
      ) //清除“数字”和“.”以外的字符
      this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(
        /^\./g,
        ''
      ) //验证第一个字符是数字
      this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(
        /\.{2,}/g,
        '.'
      ) //只保留第一个. 清除多余的
      this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(
        '.',
        '$#$'
      )
        .replace(/\./g, '')
        .replace('$#$', '.')
      this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(
        /^(\-)*(\d+)\.(\d\d).*$/,
        '$1$2.$3'
      ) //只能输入两个小数
      if (
        this.detailsList.ORMTB440CE02.indexOf('.') < 0 &&
        this.detailsList.ORMTB440CE02 != ''
      ) {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.detailsList.ORMTB440CE02 = parseFloat(
          this.detailsList.ORMTB440CE02
        )
      }
      this.$refs.topWeight.value = this.detailsList.ORMTB440CE02
    },
    topWeightChange() {
      var index = String(this.detailsList.ORMTB440CE02).indexOf('.')
      if (index == -1) return
      var numArr = this.detailsList.ORMTB440CE02.split('.')
      if (numArr[1].length == 0) {
        this.$refs.topWeight.value = numArr[0]
        this.detailsList.ORMTB440CE02 = numArr[0]
      } else {
        this.$refs.topWeight.value = numArr[0] + '.' + numArr[1]
        this.detailsList.ORMTB440CE02 = numArr[0] + '.' + numArr[1]
      }
    },
    topMoneyInput() {
      //充值金额实时校验
      this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(
        /[^\d.]/g,
        ''
      ) //清除“数字”和“.”以外的字符
      this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(
        /^\./g,
        ''
      ) //验证第一个字符是数字
      this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(
        /\.{2,}/g,
        '.'
      ) //只保留第一个. 清除多余的
      this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(
        '.',
        '$#$'
      )
        .replace(/\./g, '')
        .replace('$#$', '.')
      this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(
        /^(\-)*(\d+)\.(\d\d).*$/,
        '$1$2.$3'
      ) //只能输入两个小数
      if (
        this.detailsList.ORMTB440CA21.indexOf('.') < 0 &&
        this.detailsList.ORMTB440CA21 != ''
      ) {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.detailsList.ORMTB440CA21 = parseFloat(
          this.detailsList.ORMTB440CA21
        )
      }
      this.$refs.topMoney.value = this.detailsList.ORMTB440CA21
    },
    topMoneyChange() {
      //充值金额失去焦点数据处理
      var index = String(this.detailsList.ORMTB440CA21).indexOf('.')
      if (index == -1) return
      var numArr = this.detailsList.ORMTB440CA21.split('.')
      if (numArr[1].length == 0) {
        this.$refs.topMoney.value = numArr[0]
        this.detailsList.ORMTB440CA21 = numArr[0]
      } else {
        this.$refs.topMoney.value = numArr[0] + '.' + numArr[1]
        this.detailsList.ORMTB440CA21 = numArr[0] + '.' + numArr[1]
      }
    },
    returnReceiptserve() {
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ORMTB440CE07: this.uobj.pertb005.pertb005id, //开始时间
        ORMTB440CE08: this.uobj.pertb005.pertb005ca02,
        ORMTB440CE09: this.detailsList.ORMTB440CE02,
        ORMTB440ID: this.detailsList.ORMTB440ID,
        ORMTB440CA21: this.detailsList.ORMTB440CA21,
      }
      this.tableData = []
      var url = '/orm/ormtb440/ormtb440Confirm'
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            this.$message({
              message: '确认回执成功',
              type: 'success',
            })
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },

    djcancelOrder(row, datadj) {
      console.log(row)
      var url = '/orm/ormtb470/updateStatus'
      this.$prompt('请输入原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^.{1,}$/,
        inputErrorMessage: '原因不能为空',
      }).then(({ value }) => {
        var postData = {
          ORMTB470ID: row.ORMTB470ID,
          ORMTB470CA62: datadj, //状态
          ORMTB470CA63: value, //冻结解冻原因
        }
        let loading = this.$loading({
          lock: true,
          text: '请求中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)',
        })
        this.axios
          .post(url, postData)
          .then(res => {
            if (res.data.code == 200) {
              this.pageList()
              this.$message({
                type: 'success',
                message: '成功!',
              })
            } else {
              this.$message({
                message: res.data.message,
                type: 'error',
              })
            }
            loading.close()
          })
          .catch(() => {
            loading.close()
          })
      })
    },

    // 取消订单
    cancelOrder(row) {
      var url = '/orm/ormtb470/updateORMTB470CD00'
      this.$prompt('请输入取消原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^.{1,}$/,
        inputErrorMessage: '原因不能为空',
      }).then(({ value }) => {
        var postData = {
          ORMTB470ID: row.ORMTB470ID,
          // ORMTB440CF01: -1, //状态
          ORMTB470CA29: value, //取消原因
        }
        let loading = this.$loading({
          lock: true,
          text: '请求中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)',
        })
        this.axios
          .post(url, postData)
          .then(res => {
            if (res.data.code == 200) {
              this.pageList()
              this.$message({
                type: 'success',
                message: '取消成功!',
              })
            } else {
              this.$message({
                message: res.data.message,
                type: 'error',
              })
            }
            loading.close()
          })
          .catch(() => {
            loading.close()
          })
      })
    },
    // 客户--查询
    enterprise0ptions() {
      var postData = {}
      if (this.uobj.pertb005.pertb005cb00 == 'CUS-2') {
        postData = {
          ORMTB400ID: this.uobj.ormtb410.ORMTB410ID, //一级企业id
        }
      }
      if (this.uobj.pertb005.pertb005cb00 == 'CUS-1') {
        postData = {
          ORMTB400ID: this.uobj.ormtb400.ORMTB400ID, //一级企业id
        }
      }

      var List = [
        {
          ORMTB410ID: '',
          ORMTB410CA00: '全部',
        },
      ]
      var url = '/orm/ormtb410/selectOrmtb410s'
      this.axios.post(url, postData).then(res => {
        console.log(res)

        if (res.data.code == 200) {
          // 客户
          this.customerOptions = [...List, ...res.data.data]
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      })
    },
    materielMoPost() {
      var i = (this.enterpriseTwoOptionList || []).findIndex(
        profile => profile.SETTB99ID === this.enterpriseTwo
      )
      var url = '/set/settb109/selectPageList'
      var SETTB100ID = this.enterpriseTwoOptionList[i].SETTB100ID
      var data = {
        SETTB109CA03: '',
        SETTB109CA00: '',
        SETTB109CD01: SETTB100ID,
        SETTB99ID: this.enterpriseTwo,
        page: 1,
        limit: 1000,
      }
      var List = [
        {
          SETTB109CA00: '全部',
          SETTB109ID: '',
        },
      ]
      this.axios.post(url, data).then(res => {
        if (res.data.code == 200) {
          this.materielOptions = [...List, ...res.data.data]
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      })
    },
    erpChange() {
      if (this.enterpriseTwo != '') {
        this.materielMoPost()
      } else {
        this.materielOptions = [
          {
            SETTB109CA00: '全部',
            SETTB109ID: '',
          },
        ]
      }
    },
    // 获取下拉框信息--二级企业
    optionLists() {
      var postData = {
        type: 2,
        SETTB100CA02: '', //用户类型
      }
      if (this.uobj.pertb005.pertb005cb00 == 'CUS-2') {
        postData = {
          type: 2,
          ORMTB400ID: this.uobj.ormtb410.ORMTB400ID, //一级企业id
        }
      }
      if (this.uobj.pertb005.pertb005cb00 == 'CUS-1') {
        postData = {
          type: 2,
          ORMTB400ID: this.uobj.ormtb400.ORMTB400ID, //一级企业id
        }
      }
      // var postData = {
      // 	SETTB100CA02: '', //用户类型
      // 	ORMTB400ID: this.uobj.ormtb400.ORMTB400ID //一级企业id
      // }
      var List = [
        {
          SETTB99ID: '',
          SETTB99CA00: '全部',
        },
      ]
      var url = '/set/settb100/selectSettb100ByCa02'
      this.axios
        .post(url, postData)
        .then(res => {
          if (res.data.code == 200) {
            var data = res.data.data
            // 二级企业
            this.enterpriseTwoOptionList = [...List, ...data]
            if (this.enterpriseTwoOptionList.length == 2) {
              this.enterpriseTwo = this.enterpriseTwoOptionList[1].SETTB99ID
              this.materielMoPost()
            }
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          this.pageList()
        })
        .catch(() => {
          this.pageList()
          loading.close()
        })
    },
    // 查询
    queryClick() {
      this.startTime = this.date[0]
      this.endTime = this.date[1]
      this.pageList()
    },
    // 列表
    pageList() {
      var ORMTB400CA03
      // console.log(this.uobj)
      if (this.uobj.pertb005.pertb005cb00 == 'CUS-2') {
        ORMTB400CA03 = this.uobj.ormtb410.ORMTB410ID
      }
      if (this.uobj.pertb005.pertb005cb00 == 'CUS-1') {
        ORMTB400CA03 = this.uobj.ormtb400.ORMTB400CA03
      }

      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        startTime: this.startTime, //开始时间
        endTime: this.endTime, //结束时间
        ORMTB410ID: this.customerMo, //二级客户ID
        ORMTB470CA58: this.ORMTB470CA58,
        // ORMTB410CA03: ORMTB400CA03, //一级客户代码
        ORMTB470CA04: this.enterpriseTwo, //二级企业ID
        ORMTB470CA06: this.materielMo, //物料ID
        ORMTB470CD00: this.SETTB122CA07, //状态
        ORMTB470CA00: this.ORMTB440CA00, //订单号
        ORMTB470CA01: this.carNumber, //车牌号
        ORMTB470CA61: this.lxorde, //离线订单
        ORMTB470CN00: this.xgorde, //修改流水
		ORMTB440CN05: this.cdorde,//错单
        ORMTB470CA12: this.ORMTB470CA12,
        ORMTB470CA40: this.ORMTB470CA40,
        ORMTB410CA04: this.ORMTB410CA04,
        page: this.pageMo,
        limit: this.limitMo,
        timeType: this.timeType,
        dcmore: '',
		source:this.orderSource,//订单出处
		ORMTB470CN18: this.cdorde//错单
      }
      this.tableData = []
      var url = '/orm/ormtb470/selectPageList'
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          // console.log(res)
          if (res.data.code == 200) {
            var data = res.data.data.dataList
            // console.log(data)
            this.pagingPageMo = res.data.count
            for (var i = 0; i < data.length; i++) {
              var customerName = ''
              if (data[i]['ORMTB470CD00'] == '-1') {
                data[i]['ORMTB440CF01text'] = '取消'
              } else if (data[i]['ORMTB470CD00'] == '0') {
                data[i]['ORMTB440CF01text'] = '已接单'
              } else if (data[i]['ORMTB470CD00'] == '1') {
                data[i]['ORMTB440CF01text'] = '提货中'
              } else if (data[i]['ORMTB470CD00'] == '2') {
                data[i]['ORMTB440CF01text'] = '已出厂结算'
              } else if (data[i]['ORMTB470CD00'] == '3') {
                data[i]['ORMTB440CF01text'] = '待审核磅单'
              } else if (data[i]['ORMTB470CD00'] == '4') {
                data[i]['ORMTB440CF01text'] = '已审核待确认'
              } else if (data[i]['ORMTB470CD00'] == '5') {
                data[i]['ORMTB440CF01text'] = '已完成'
              } else if (data[i]['ORMTB470CD00'] == '-2') {
                data[i]['ORMTB440CF01text'] = '申请取消'
              } else if (data[i]['ORMTB470CD00'] == '-3') {
                data[i]['ORMTB440CF01text'] = '磅单审核已拒绝'
              }

              if (data[i]['ORMTB470CD00'] == '-2') {
                if (data[i]['ORMTB470CD01'] == '0') {
                  data[i]['auditText'] = '未审核'
                } else if (data[i]['ORMTB470CD01'] == '1') {
                  data[i]['auditText'] = '通过'
                } else if (data[i]['ORMTB470CD01'] == '2') {
                  data[i]['auditText'] = '拒绝'
                }
              }

              // else if (data[i]['ORMTB440CF01'] == '6') {
              // 	data[i]['auditText'] = '未审核'
              // }
              else {
                data[i]['auditText'] = '通过'
                // if (data[i].ORMTB440CH00 == 0) {
                // 	data[i].isauditOrder = 0
                // }
                // if (data[i].ORMTB440CH00 == 1 && data[i].ORMTB440CH01 == 0) {
                // 	data[i].isauditOrder = 1
                // }
                // if (data[i].ORMTB440CH00 == 1 && data[i].ORMTB440CH01 == 1) {
                // 	data[i].isauditOrder = 0
                // }
                // if (data[i]['ORMTB440CH01'] == '0') {
                // 	data[i]['auditText'] = '未审核'
                // } else if (data[i]['ORMTB440CH01'] == '1') {
                // 	data[i]['auditText'] = '通过'
                // } else if (data[i]['ORMTB440CH01'] == '2') {
                // 	data[i]['auditText'] = '拒绝'
                // }
              }
            }
            this.tableData = data
            this.jscc = res.data.data.jscc
            this.jsje = res.data.data.jsje
            this.jszl = res.data.data.jszl
            this.jsyf = res.data.data.jsyf

            this.pdcc = res.data.data.pdcc
            this.pdje = res.data.data.pdje
            this.pdzl = res.data.data.pdzl
            this.pdyf = res.data.data.pdyf

            this.wccc = res.data.data.wccc
            this.wcje = res.data.data.wcje
            this.wcyf = res.data.data.wcyf
            this.jsyfsjtj = res.data.data.wcjsyf
            this.glf = res.data.data.fwf
            this.wczl = res.data.data.wczl
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    UploadClick(row) {
      this.ORMTB470CA00 = row.ORMTB470ID
    },
    ewmDetailsClick(row) {
      // console.log(row)
      this.ewmDetilsShow = true
      this.queryermdetile(row)
    },
    inputFileChange(e) {
      let file = e.target.files[0]
      let formData = new FormData()
      formData.append('file', file)
      formData.append('ORMTB470ID', this.ORMTB470CA00)
      let loading = this.$loading({
        lock: true,
        text: '上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var url = '/orm/ormtb470/upload'
      this.axios
        .post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            this.$message({
              message: '上传成功',
              type: 'success',
            })
            this.pageList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    inputWeightClick(row) {
      console.log(row)
      //
      this.inputWeightShow = true
      if (row.ORMTB470CA04 == '10000108') {
        this.dcjsiput = false
      } else {
        this.dcjsiput = true
      }

      this.orderId = row.ORMTB470CA04
      this.newOrderId = row.ORMTB470ID
      this.querydetile(row)
      this.getSelectMaterial(row)

      this.fileListccbd = []
    },
    inputWeightClose() {
      this.weightOpt.tare = ''
      // this.weightOpt.gross = ''
      // this.detailsList.ORMTB440CC02 = ''
      // this.detailsList.ORMTB440CC02 = ''
      // this.detailsList.ORMTB470CA21 = ''
      this.weightOpt.jsprice = ''
    },
    // 获取结算金额
    async getSettlementAmount() {
      // console.log(typeof this.weightOpt.tare)
      if (!this.materialValue) return
      if (this.weightOpt.price < 0) return
      if (this.weightOpt.tare === '') return

      var params = {
        ORMTB440CC01: this.materialValue,
        ORMTB440CA02: this.detailsList.ORMTB410CA01,
        ORMTB440CA04: this.detailsList.ORMTB470CA04,
        ORMTB440CC03: this.detailsList.ORMTB470CA20,
        ORMTB440CC04: this.weightOpt.tare,
        ORMTB440CC03: this.weightOpt.price,
      }
      params = qs.stringify(params)

      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var url = '/orm/ormtb440/orderCompleteBeforeBack'
      this.axios
        .post(url, params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            this.weightOpt.jsprice = res.data.data
            // this.pageList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    inputWeightConfirm() {
      var {
        ORMTB470ID, // 派单记录ID - 隐藏

        // ORMTB470CA23, // 结算金额 -可修改
      } = this.detailsList
      var ORMTB470CA18 = this.materialValue // 物料id
      var ORMTB470CA19 = this.materialList.find(
        em => em.value === this.materialValue
      ).lable // 结算物料 -可修改
      var {
        tare, // 结算重量 -不修改
      } = this.weightOpt
      if (!tare) {
        return this.$message({
          message: '请输入净重',
          type: 'error',
        })
      }

      if (
        this.detailsList.ORMTB470CA04 == '10000106' ||
        this.detailsList.ORMTB470CA66 == '1'
      ) {
        if (this.ruleForm.csAvatar == '') {
          return this.$message({
            message: '请上传出厂磅单',
            type: 'error',
          })
        }
      }

      if (this.orderId == '10000106' || this.orderId == '10000155') {
        this.dcmore = this.weightOpt.price
      } else {
        this.dcmore = ''
      }
      // if (!gross) {
      // 	return this.$message({
      // 		message: '请输入皮重',
      // 		type: 'error'
      // 	});
      // }
      var params = {
        ORMTB470ID,
        ORMTB470CA18, // 物料id
        ORMTB470CA19: ORMTB470CA19,
        ORMTB470CA21: tare,
        ORMTB470CA67: this.ruleForm.csAvatar,
		fileId: this.ruleForm.fileId,
        //ORMTB440CC03: this.weightOpt.price,
        ORMTB470CA20: this.dcmore,
      }
      params = qs.stringify(params)

      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var url = '/orm/ormtb470/update'
      this.axios
        .post(url, params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            this.tableData = []
            this.$message({
              message: '提交成功',
              type: 'success',
            })
            this.inputWeightShow = false
            this.pageList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    inputWeightFormat(e, type, type2) {
      console.log('type', type, type2)
      let value = e.target.value
      // console.log(value)
      // console.log(type)
      value = value.replace(/[^\d.]/g, '') //清除“数字”和“.”以外的字符
      value = value.replace(/^\./g, '') //验证第一个字符是数字
      value = value.replace(/\.{2,}/g, '.') //只保留第一个. 清除多余的
      value = value
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
      value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') //只能输入两个小数
      this.weightOpt.tare = value
      if (value.indexOf('.') < 0 && value != '') {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value)
      }
      this.weightOpt[type] = value

      if (type2 == 'hx') {
        this.getFree() //获取结算运费
      }
    },
    inputWeightFormat1(e, type, type2) {
      let value = e.target.value
      // console.log(value)
      // console.log(type)
      value = value.replace(/[^\d.]/g, '') //清除“数字”和“.”以外的字符
      value = value.replace(/^\./g, '') //验证第一个字符是数字
      value = value.replace(/\.{2,}/g, '.') //只保留第一个. 清除多余的
      value = value
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
      value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') //只能输入两个小数
      if (value.indexOf('.') < 0 && value != '') {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value)
      }

      this.$set(this.weightOpt, 'price', value)

      if (type2 == 'hx') {
        this.getFree() //获取结算运费
      }
    },
    inputWeightTotalFormat(e) {
      let value = e.target.value
      value = value.replace(/[^\d.]/g, '') //清除“数字”和“.”以外的字符
      value = value.replace(/^\./g, '') //验证第一个字符是数字
      value = value.replace(/\.{2,}/g, '.') //只保留第一个. 清除多余的
      value = value
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
      value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') //只能输入两个小数
      if (value.indexOf('.') < 0 && value != '') {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value)
      }
      this.weightOpt.jsprice = value
    },
    // 详情
    DetailsClick(row) {
      // console.log(row)
      this.oerderDetilsShow = true
      this.querydetile(row)
    },
    orderAudit(row) {
      this.orderAuditShow = true
      this.examineObj = row
      this.querydetile(row)
    },
    orderAudit1(row, type) {
      this.orderAuditShow1 = true
      this.examineObj = row
      this.querydetile(row, type)
    },
    orderAudit2(row) {
      this.orderAuditShow2 = true
      this.examineObj = row
      // console.log(this.examineObj)
	    // console.log(this.formData.fileList)
		this.formData.fileList = []
      this.querydetile(row)
    },
    isorderAudit(row) {
      this.isorderAuditShow = true
      this.querydetile(row)
    },
    returnReceipt(row) {
      this.returnReceiptShow = true
      this.querydetile(row)
    },
    examineOrder() {
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ORMTB470ID: this.examineObj.ORMTB470ID,
        ORMTB470CA48: this.detailsList.ORMTB470CA48,
      }
      this.tableData = []
      var url = '/orm/ormtb470/examine'
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            this.$message({
              message: '审核成功',
              type: 'success',
            })
            this.orderAuditShow = false
            this.pageList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },

    examineWriteOffOrder() {
      if(this.detailsList.ORMTB470CA52 < this.detailsList.ORMTB470CA14){
        return this.$message({
          message: '发单运费不能低于接单运费',
          type: 'warning',
        })
      }
      //核销磅单
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ORMTB470ID: this.examineObj.ORMTB470ID,
        ORMTB470CC05: this.detailsList.ORMTB470CC05,
        ORMTB470CA14: this.detailsList.ORMTB470CA14,
        ORMTB470CA33: this.detailsList.ORMTB470CA33,
        ORMTB470CA72: this.detailsList.ORMTB470CA72,
        ORMTB470CA52: this.detailsList.ORMTB470CA52,
      }
      this.tableData = []
      var url = '/orm/ormtb470/complete'
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            this.$message({
              message: '成功',
              type: 'success',
            })
            this.orderAuditShow1 = false
            this.pageList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },

    examinebdOffOrder() {
      //上传磅单

      // console.log(this.detailsList.ph)
      if (this.detailsList.ph == '' || this.detailsList.ph == undefined) {
        this.$message({
          message: '请输入票号',
          type: 'error',
        })
        return
      }
      if (this.detailsList.ORMTB470CC05 == '') {
        this.$message({
          message: '请输入卸货重量',
          type: 'error',
        })
        return
      }

      // this.formData.fileList.push({
      // 	url: this.dialogImageUrl

      // });

      // this.formData.fileList.push(this.dialogImageUrl)
      // console.log(this.formData.fileList)
      // console.log(this.dialogImageUrl)

      if (this.formData.fileList.length <= 0) {
        this.$message({
          message: '请上传磅单',
          type: 'error',
        })
        return
      }
      // if (this.dialogImageUrl=='') {
      // 	this.$message({
      // 		message: '请上传磅单',
      // 		type: 'error'
      // 	});
      // 	return
      // }

      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ORMTB470ID: this.examineObj.ORMTB470ID,
        ORMTB470CA35: this.formData.fileList[0].url,
		fileId:this.formData.fileId,
        ORMTB470CA48: this.detailsList.ph,
        ORMTB470CC05: this.detailsList.ORMTB470CC05,
      }
      var url = '/orm/ormtb470/confirm'
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: 'success',
            })
            this.orderAuditShow2 = false
            this.pageList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },

    queryermdetile(row) {
      var postData = {
        ORMTB470ID: row.ORMTB470ID, //流水id
      }
      this.detailsList = ''
      var url = '/orm/ormtb470/getErwei'
      this.axios.post(url, postData).then(res => {
        if (res.data.code == 200) {
          console.log(res)
          this.ewmdetailsList = res.data.data
          this.ewmdetailsList.ORMTB440CA22Img =
            'data:image/png;base64,' + res.data.data.ORMTB470CA30
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      })
    },
    updateOrder() {
      var url = '/orm/ormtb470/updateORMTB470CA44'
      this.$prompt('请输入原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^.{1,}$/,
        inputErrorMessage: '原因不能为空',
      }).then(({ value }) => {
        var postData = {
          ORMTB470CA44: value,
          ORMTB470ID: this.examineObj.ORMTB470ID,
        }
        let loading = this.$loading({
          lock: true,
          text: '请求中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)',
        })
        this.tableData = []
        this.axios
          .post(url, postData)
          .then(res => {
            setTimeout(() => {
              loading.close()
            }, 400)
            if (res.data.code == 200) {
              this.$message({
                message: '审核成功',
                type: 'success',
              })
              this.orderAuditShow = false
              this.pageList()
            } else {
              this.$message({
                message: res.data.message,
                type: 'error',
              })
            }
          })
          .catch(() => {
            loading.close()
          })
      })
    },

    orderAuditServe(type) {
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ORMTB440CG00: type,
        ORMTB440CG02: this.uobj.pertb005.pertb005ca02,
        ORMTB440ID: this.detailsList.ORMTB440ID,
        ORMTB440CA02: this.detailsList.ORMTB440CA02,
        ORMTB440CA11: this.detailsList.ORMTB440CA11,
        ORMTB440CA12: this.detailsList.ORMTB440CA12,
      }
      this.tableData = []
      var url = '/orm/ormtb440/updateORMTB440CG00'
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            this.$message({
              message: '审核成功',
              type: 'success',
            })
            this.orderAuditShow = false
            this.pageList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    isorderAuditServe(type) {
      // console.log(type)
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ORMTB470CD01: type,
        ORMTB470ID: this.detailsList.ORMTB470ID,
        ORMTB470CA44: this.isorderAuditText,
      }
      this.tableData = []
      var url = '/orm/ormtb470/updateORMTB470CD01NEW'
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            this.$message({
              message: '审核成功',
              type: 'success',
            })
            this.isorderAuditShow = false
            this.pageList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    querydetile(row, type) {
      var postData = {
        ORMTB470ID: row.ORMTB470ID, //流水id
      }
      this.detailsList = ''
      var url = '/orm/ormtb470/selectDetails'
      this.axios.post(url, postData).then(res => {
        if (res.data.code == 200) {
          // console.log(res)
          this.detailsList = res.data.data

          this.weightOpt.price = this.detailsList.ORMTB470CA08
          console.log(this.detailsList)

          this.dialogVisible = true
          this.dialogImageUrl = this.detailsList.ORMTB470CA35
          this.bdurlList.push(this.detailsList.ORMTB470CA35)

          // console.log(this.detailsList)
          // this.DetailsWatersrcList = [this.detailsList.ORMTB440CE01]
          if (this.detailsList.ORMTB470CA35)
            this.DetailsWeightrcList = [this.detailsList.ORMTB470CA35]
          // this.weightOpt.price = this.detailsList.ORMTB470CA08
          // console.log(row.ORMTB470CD00)
          if (row.ORMTB470CD00 == 0 && row.ORMTB470CA30) {
            this.weightOpt.tare = 0
            // this.weightOpt.jsprice = ''
            this.getSelectMaterial(row)
          }
          if (type == 'hx') {
            this.getFree() //获取结算运费
          }
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      })
    },
    handleCheckAllChange(val) {
      this.checkedCities = val ? this.cities : []
      this.isIndeterminate = false
      this.tableHeadList = val ? this.tableHeadListInit : []
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.cities.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length
      var changearr = this.checkedCities
      var initarr = this.tableHeadListInit
      this.tableHeadList = this.$baseAPI.columnSetup(changearr, initarr)
    },

    dateFtt(fmt, date) {
      //author: meizz
      var o = {
        'M+': date.getMonth() + 1, //月份
        'd+': date.getDate(), //日
        'h+': date.getHours(), //小时
        'm+': date.getMinutes(), //分
        's+': date.getSeconds(), //秒
        'q+': Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
      }
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + '').substr(4 - RegExp.$1.length)
        )
      for (var k in o)
        if (new RegExp('(' + k + ')').test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ('00' + o[k]).substr(('' + o[k]).length)
          )
      return fmt
    },

    //获取当前时间
    getNowDay() {
      var date = new Date().getTime()
      var Ming = new Date().getTime() + 24 * 60 * 60 * 1000
      var data = this.dateFtt('yyyy-MM-dd', new Date(Ming))
      var enddata = this.dateFtt('yyyy-MM-dd', new Date(date))
      data = `${data} ${this.exchangeTiem || '00:00:00'}`
      enddata = `${enddata} ${this.exchangeTiem || '00:00:00'}`
      this.date = [enddata, data]
      this.dateNowDayActive = true
      this.dateYesterdayActive = false
      this.dateNowMonthActive = false
      this.dateLastMonthActive = false
    },
    datePickerChange(e) {
      this.dateNowDayActive = false
      this.dateYesterdayActive = false
      this.dateNowMonthActive = false
      this.dateLastMonthActive = false
    },
    //获取昨天时间
    getYesterday() {
      var hms = new Date().getTime() - 24 * 60 * 60 * 1000
      var Ming = new Date().getTime()
      var nowDay = this.dateFtt('yyyy-MM-dd', new Date(hms))
      var enddata = this.dateFtt('yyyy-MM-dd', new Date(Ming))
      nowDay = `${nowDay} ${this.exchangeTiem || '00:00:00'}`
      enddata = `${enddata} ${this.exchangeTiem || '00:00:00'}`
      this.date = [nowDay, enddata]
      this.dateNowDayActive = false
      this.dateYesterdayActive = true
      this.dateNowMonthActive = false
      this.dateLastMonthActive = false
    },
    //获取当月时间
    sameMonth() {
      var date = new Date()
      var hms = date.setDate(1)
      var firstDay = this.dateFtt('yyyy-MM-dd', new Date(hms))
      firstDay = `${firstDay} ${this.exchangeTiem || '00:00:00'}`
      var nextdate = new Date().getTime() + 24 * 60 * 60 * 1000
      var nextDay = this.dateFtt('yyyy-MM-dd', new Date(nextdate))
      nextDay = `${nextDay} ${this.exchangeTiem || '00:00:00'}`
      this.date = [firstDay, nextDay]
      this.startTime = this.date[0]
      this.endTime = this.date[1]
      this.dateNowDayActive = false
      this.dateYesterdayActive = false
      this.dateNowMonthActive = true
      this.dateLastMonthActive = false
    },
    //获取上月时间
    lastMonth() {
      var nowdays = new Date()
      var year = nowdays.getFullYear()
      var month = nowdays.getMonth()
      var lastyear = year
      var lastmonth = month
      if (month == 0) {
        month = 12
        year = year - 1
      }
      if (month == 12) {
        lastmonth = 1
      } else {
        lastmonth = lastmonth + 1 * 1
      }
      if (month < 10) {
        month = '0' + month
      }
      if (lastmonth < 10) {
        lastmonth = '0' + lastmonth
      }
      var firstDayOfPreMonth = year + '-' + month + '-' + '01'
      var firstDayOfPreMonth = `${year}-${month}-01 ${this.exchangeTiem ||
        '00:00:00'}`
      // var lastDay = new Date(lastyear, lastmonth, 0);
      let lastDayOfPreMonth = `${lastyear}-${lastmonth}-01 ${this
        .exchangeTiem || '00:00:00'}`
      this.date = [firstDayOfPreMonth, lastDayOfPreMonth]
      this.dateNowDayActive = false
      this.dateYesterdayActive = false
      this.dateNowMonthActive = false
      this.dateLastMonthActive = true
    },
    handleSizeChange(val) {
      this.pageMo = 1
      this.limitMo = val
      this.pageList()
    },
    // 点击页码
    handleCurrentChange(val) {
      this.pageMo = val
      this.pageList()
    },
  },
}
</script>

<style scoped>
.CustomerfillingDig-tab {
  padding-left: 20px;
}

.CustomerfillingDig-tab-li,
.rechargeType-tab-li {
  display: flex;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  color: #333;
  vertical-align: top;
}

.CustomerfillingDig-tab-li > div {
  border: 1px solid #cdcdcd;
  border-top: none;
}

.CustomerfillingDig-tab-li > div:first-child {
  border-right: none;
}

.CustomerfillingDig-tab-li:first-child > div {
  border-top: 1px solid #cdcdcd;
}

.CustomerfillingDig-tab-li > div:last-child,
.rechargeType-tab-li > div:last-child {
  border: none;
  color: #ff4d35;
}

.CustomerfillingDig-tab-li-text {
  flex: 0.8;
  background: rgba(240, 252, 255, 1);
}

.CustomerfillingDig-tab-li-ipt {
  flex: 0.8;
}

.rechargeType-tab-li-text {
  flex: 0.35;
}

.rechargeType-tab-li-ipt {
  flex: 0.7;
}

.CustomerfillingDig-tab-li-ipt input,
.rechargeType-tab-li-ipt input {
  height: 46px;
  width: 100%;

  text-align: center;

  box-sizing: border-box;
  font-size: 16px;
  color: #333;
}

.CustomerfillingDig-tab-li-ipt input {
  outline: none;
  border: none;
  vertical-align: top;
}

.rechargeType-tab-li-ipt input {
  /* border-radius: 8px; */
  /* outline: none; */
}

.CustomerfillingDig-tab-li-b,
.rechargeType-tab-li-b {
  flex: 0.3;
}

.CustomerfillingDig-tab-btn {
  text-align: center;
  margin-top: 30px;
}

.DWD-li {
  display: flex;
  height: 35px;
  line-height: 35px;
  box-sizing: border-box;
  border: 1px solid #999;
  font-size: 16px;
  color: #333;
}

.DWD-li > div {
  padding: 0 5px;
  height: 34px;
  overflow: hidden;
  box-sizing: border-box;
}

.DWD-li-title {
  width: 150px;
  text-align: center;
  border-right: 1px solid #999;
  background-color: rgba(0, 163, 255, 0.1);
}

.DWD-li-text {
  flex: 1;
}

.DWD-li-text input {
  width: 100%;
  height: 35px;
  line-height: 35px;
  font-size: 0.833vw;
  border: none;
  outline: none;
}

.DWD-li + .DWD-li {
  border-top: none;
}

.DWD-table {
  display: flex;
}

.DWD-table-left-flex {
  flex: 1;
}

.DWD-table > div > div {
  padding: 0 5px;
  height: 35px;
  line-height: 35px;
  overflow: hidden;
  text-align: center;
  border-right: 1px solid #999;
  border-bottom: 1px solid #999;
  box-sizing: border-box;
}

.DWD-table > div > div:first-child {
  background-color: rgba(0, 163, 255, 0.1);
}

.DWD-table-left-title > div {
  width: 101px;
  text-align: center;
  background-color: rgba(0, 163, 255, 0.1);
}

.DWD-table .DWD-table-left-title > div {
  padding: 0 5px;
  height: 35px;
  line-height: 35px;
  overflow: hidden;
  box-sizing: border-box;
  border-left: 1px solid #999;
  border-bottom: 1px solid #999;
}

.DetailsWater-img {
  margin-top: 30px;
}

.DetailsWater-img-text {
  display: inline-block;
  width: 101px;
  text-align: center;
  vertical-align: top;
}

.car-number-add {
  /* text-transform: uppercase; */
}

.billOperationRecord-table {
  padding: 30px 20px 0;
}

.public_singleMenu .pulic_carNumber {
  margin-top: 6px;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  font-size: 14px;
  display: inline-block;
}

.pulic_operatArea_now:hover,
.public_operatArea_yesterday:hover {
  background-color: #ccc;
}

/* 新增--列表宽度 */
.billOperationRecord .systemCodePC-add-code-table-li-ipt {
  flex: 1.5;
}

.fontBlue {
  color: rgba(25, 159, 255, 1) !important;
}

.public_oparetionBlock_Menu .pulic_carNumber {
  margin-top: 6px;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  font-size: 14px;
  display: inline-block;
}

.billOperationRecord .public_oparetionBlock_Menu {
  height: 45px;
  align-items: center;
}

.billOperationRecord {
  background-color: #f3f3f3;
}

.billOperationRecord th,
.billOperationRecord td {
  text-align: center !important;
}

/* 统计 START*/
.imgStatistics {
  width: 40px;
  height: 40px;
}

.payType {
  /* font-size: 15px; */
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(102, 102, 102, 1);
  line-height: 26px;
}

.singular {
  /* font-size: 14px; */
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  vertical-align: middle;
  padding-left: 10px;
}

.Amount {
  /* font-size: 14px; */
  font-family: Microsoft YaHei;
  /* font-weight:bold; */
  line-height: 30px;
  vertical-align: middle;
  padding-left: 10px;
}

.pulic_statistics_titlt {
  line-height: 40px;
  /* font-size: 14px; */
}

.billDetails-statistics {
  justify-content: space-around;
}

.public_statisticsInfo {
  margin-top: 5px;
  margin-bottom: 10px;
}

.input_ {
  display: flex;
  height: 2.34vw;
  line-height: 2vw;
}

::v-deep .el-input__inner {
  /* width: 7.083vw; */
  height: 1.7vw;
}

:v-deep .el-input {
  width: unset;
}

/* 统计 END*/

.orderBtn {
  display: inline-block;
  width: 60px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #fff;
  border-radius: 5px;
}

.orderBtnType1 {
  background-color: #68d6a8;
}

.orderBtnType2 {
  background-color: #e2af07;
}
.orderBtn1 {
  background-color:rgb(9, 117, 218);
}
.orderBtn2 {
  background-color:red;
}
</style>
